import React, { useContext, useEffect, useState,useMemo,useCallback } from 'react'
import { Table, DatePicker, Select, Button, message, Tabs, Spin, Cascader, Tag, Row, Col ,Dropdown,Checkbox,Menu,Progress,Popconfirm} from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { StateContext} from '../../../state';
import { StateDeviceContext } from '../../../state_device';
import http from '../../../../../utils/server'
import { Line } from '@ant-design/plots';
import './style.less'
import moment, { duration } from 'moment';
import { Mode } from '../../../../../App'
import html2canvas from 'html2canvas';
import * as echarts from 'echarts';
import { render } from 'less';


// 绘制图表
const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
var todayTime=0;

const customWeekStartEndFormat = value =>
  `${moment(value).startOf('week').format('MM/DD')} ~ ${moment(value)
    .endOf('week')
    .format('MM/DD')}`;

function formatDateTimes(inputTime) {
    var date = new Date(inputTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;
    second = second < 10 ? ('0' + second) : second;
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
};

function exportCsv(obj) {
    var title = obj.title;
    var titleForKey = Object.keys(obj.data[0]);
    var data = obj.data;
    var str = [];
    str.push(obj.title.join(",") + "\n");
    for (var i = 0; i < data.length; i++) {
        var temp = [];
        for (var j = 0; j < titleForKey.length; j++) {
            temp.push(data[i][titleForKey[j]]);
        }
        str.push(temp.join(",") + "\n");
    }
    var blob = new Blob(['\uFEFF' + str.join('')], {
        type: 'text/plain;charset=utf-8',
    });
    var downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = "export.csv";
    downloadLink.click();
}

const VirtualTable = (props) => {
//     const { columns, scroll } = props;
//     const [tableWidth, setTableWidth] = useState(0);
//     const widthColumnCount = columns.filter(({ width }) => !width).length;
//     const mergedColumns = columns.map((column) => {
//       if (column.width) {
//         return column;
//       }
//       return {
//         ...column,
//         width: Math.floor(tableWidth / widthColumnCount),
//       };
//     });
//     const gridRef = useRef();
//     const [connectObject] = useState(() => {
//       const obj = {};
//       Object.defineProperty(obj, 'scrollLeft', {
//         get: () => {
//           if (gridRef.current) {
//             return gridRef.current?.state?.scrollLeft;
//           }
//           return null;
//         },
//         set: (scrollLeft) => {
//           if (gridRef.current) {
//             gridRef.current.scrollTo({
//               scrollLeft,
//             });
//           }
//         },
//       });
//       return obj;
//     });
//     const resetVirtualGrid = () => {
//       gridRef.current?.resetAfterIndices({
//         columnIndex: 0,
//         shouldForceUpdate: true,
//       });
//     };
//     useEffect(() => resetVirtualGrid, [tableWidth]);
//   const renderVirtualList = (rawData, { scrollbarSize, ref, onScroll }) => {
//     ref.current = connectObject;
//     const totalHeight = rawData.length * 54;
//     return (
//       <Grid
//         ref={gridRef}
//         className="virtual-grid"
//         columnCount={mergedColumns.length}
//         columnWidth={(index) => {
//           const { width } = mergedColumns[index];
//           return totalHeight > scroll.y && index === mergedColumns.length - 1
//             ? width - scrollbarSize - 1
//             : width;
//         }}
//         height={scroll.y}
//         rowCount={rawData.length}
//         rowHeight={() => 54}
//         width={tableWidth}
//         onScroll={({ scrollLeft }) => {
//           onScroll({
//             scrollLeft,
//           });
//         }}
//       >
//         {({ columnIndex, rowIndex, style }) => {

//             const record = rawData[rowIndex];
//             const column = columns[columnIndex];
//             return  <div
//             style={{
//                 ...style,
//                 display: 'flex',
//                 alignItems: 'center',
//                 padding: '0 12px',
//                 borderBottom: '1px solid #f0f0f0',
//                 background: rowIndex % 2 ? '#fafafa' : 'white',
//                 boxSizing: 'border-box',
//                 justifyContent: 'center'
//               }}
//           >
//             {/* {rawData[rowIndex][mergedColumns[columnIndex].dataIndex]} */}
//             {column.render 
//                 ? column.render(record[column.dataIndex], record, rowIndex)
//                 : record[column.dataIndex]}
//           </div>
//         }}
//       </Grid>
//     );
//   };
//   return (
//     <ResizeObserver
//       onResize={({ width }) => {
//         setTableWidth(width);
//       }}
//     >
//       <Table
//         {...props}
//         className="virtual-table"
//         columns={mergedColumns}
//         pagination={false}
//         components={{
//           body: renderVirtualList,
//         }}
//       />
//     </ResizeObserver>
//   );
};

const HumidityCell  = ({text, record,node,name}) => {

    if (record['humi_switch' + node] === 0 || record['humi_enable' + node] === 0) {
        return <div>--</div>;
    }
    if (text === undefined || text === null) {
        return <div></div>;
    }
    const isSpecialValue = [102.2, 102.3, -102.2, -102.3].includes(text);
    let displayText = isSpecialValue ? " NL" : Number(text).toFixed(1);
    let color = record['humi_alarm' + node] === 1 ? 'red' : 'black';
    if(name==='状态'){
        displayText = text === 1 ? "报警" : '正常';
        color = text === 1? 'red' : 'black';
    }
    if(name==='上下限'){
        displayText = `${text.toFixed(1)}~${record['humi_l' + node].toFixed(1)}`;
        color = 'black'
    }
    return <div style={{ color }}>{displayText}</div>;

};
const DevSelect = ({ selDevOptions, showNodeName, showDevName, onDataChange }) => {
    return (
        <div style={{display:'flex',alignItems:'center',flex:1}}>
            <span style={{ fontSize: 14}}>主机</span>
            <Select 
                showSearch 
                optionFilterProp="label" 
                allowClear 
                disabled={showNodeName.length > 0}
                filterOption={(input, opt) =>
                    opt.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onChange={value => {
                    // 这里不能直接改父组件的 state，需要通过回调通知父组件
                    onDataChange(value); 
                }}
                options={selDevOptions}
                value={showDevName}
                style={{ width: 200, marginLeft: 10 }}
                placeholder="选择主机" 
            />
        </div>
    );
};
const NodeSelect = ({ selNodeOptions, showNodeName, showDevName, onDataChange,show }) => {
    return (
        <div style={{display:'flex',alignItems:'center',flex:1}}>
            <span style={{ fontSize: 14}}>测点</span>
            <Select allowClear showSearch 
            optionFilterProp="label"
            mode="multiple"
            disabled={!(showDevName === null || showDevName === undefined)}
            filterOption={(input, opt) =>
                opt.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            value={showNodeName}
            maxTagCount = 'responsive'
            style={{ width: show?200:360, marginLeft: 10}}
            placeholder="选择测点"
            onChange={value => {
                // 这里不能直接改父组件的 state，需要通过回调通知父组件
                onDataChange(value); 
            }}
            options={selNodeOptions}
        >
        </Select>
    </div>
    );
};
function getparent(arr, pid, name) {
    let p = arr.filter(ar => ar.id === pid);
    if(p.length>0){
      name.push(p[0].id);
      p[0].type !== 101 && getparent(arr, p[0].parent, name);
    }
}

function isMoreThan31Days(dateStr1, dateStr2) {
    const time1 = new Date(dateStr1).getTime();
    const time2 = new Date(dateStr2).getTime();

    // 计算绝对时间差（毫秒）
    const diffInMs = Math.abs(time1 - time2);

    // 31天的毫秒数 = 31 * 24 * 60 * 60 * 1000
    const thirtyOneDaysInMs = 31 * 24 * 60 * 60 * 1000;

    return diffInMs > thirtyOneDaysInMs;
}
function History(props) {
    const [isDataPage,setIsDataPage] = useState(false);
    const [tableKey, setTableKey] = useState('initial');
    const [queryMode,setQueryMode] = useState(true)//低分辨率下 按什么类型查询
    const { state, dispatch } = useContext(StateContext)//全局文档
    const { state_device, dispatch_device } = useContext(StateDeviceContext)//全局文档 设备实时状态
    const [loading, setLoading] = useState(false);//查询状态
    const [showDevName, setShowDevName] = useState(null);//选中的主机名
    const [selDevOptions, setSelDevOptions] = useState([]);//区域主机选项
    const [selNodeOptions, setSelNodeOptions] = useState([]);//区域主机选项
    const [devFliters, setDevFliters] = useState([]);//所有主机选项
    const [dis, setDis] = useState('');
    const [isHumi, setIsHumi] = useState(false);
    const [selNode, setSelNode] = useState([]);
    const [selNodeColums, setSelNodeColums] = useState([]);//多测点查询表格列显示内容
    const [selDevice, setSelDevice] = useState({});//已选择的测点
    const [showUnitName,setShowUnitName] = useState('温度')
    const [showUnit,setShowUnit] = useState('℃');
    const [startTime, setStartTime] = useState('')
    const [endTime, setEndTime] = useState('')
    const [selTime, setSelTime] = useState(false)
    const [data, setData] = useState([])//报表数据
    const [dataP, setDataP] = useState([])
    const [dataF, setDataF] = useState({ tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 })//查询设备的最大 最小 平均值
    const [dataChart, setdataChart] = useState([])//直线图数据
    const [nodeFliters, setNodeFliters] = useState([]);
    const [showNodeName, setShowNodeName] = useState([]);
    const [interval,setInterval] = useState(0);
    const [userName,setUserName] = useState('');
    const [localCompany,setLocalCompany] = useState('');//本地公司名称
    const [dateTime,setDateTime] = useState('');//周期报表时间
    const [startWeek,setStartWeek] = useState('');//周报表开始时间
    const [endWeek,setEndWeek] = useState('');//周报表结束时间
    const [monthTime,setMonthTime] = useState('');//月报表时间
    const [AMTimes,setAMTimes] = useState([9]);//报表每日上午时间点
    const [PMTimes,setPMTimes] = useState([15]);//报表每日上午时间点
    const [tableType,setTableType] = useState(0);//报表类型 0普通历史数据  1日报表  2周报表 3月报表
    const [selNodeType,setSelNodeType] = useState(201);//设备主机类型  类型不同单位显示不同
    const [seriesTempData,setSeriesTempData] = useState([]);
    const [dataWainF, setDataWainF] = useState({ tl: 0, th: 0,  hl: 0, hh: 0 })
    const [showBound,setShowBound] = useState(false);
    const [selDevs,setSelDevs] = useState([]);
    const [recordCount,setRecordCount] = useState('');//记录条数
    const [tabKey,setTabKey] = useState("1")
    const [tableCurrent,setTableCurrent] = useState(1)
    const [tablePageSize,setTablePageSize] = useState(10)
    const [isExportHumi,setIsExportHumi] = useState(true);
    const [showBoundWarnT,setShowBoundWarnT] = useState(false);
    const [showBoundWarnH,setShowBoundWarnH] = useState(false);
    const [dataWarnT,setDataWarnT] = useState({tl:0,th:0});
    const [dataWarnH,setDataWarnH] = useState({hl:0,hh:0});
    const [showHisModeNew,setShowHisModeNew] = useState(false)
    const [myChartP,setMyChartP] = useState()
    const [showHisLimit,setShowHisLimit] = useState(false)
    const [hisType,setHisType] = useState(0);
    const [tooltip, setTooltip] = useState({showTitle: true,shared: true})
    const [tooltip1, setTooltip1] = useState({trigger: 'axis'})
    const [isPDFCol,setIsPDFCol] = useState(false)
    const [getDataPro,setDataPro] = useState(0)
    const [selDevSt,setSelDevSt] = useState([])
    const [selDis,setSelDis] = useState([])
    const [co2Datas,setCo2Datas] = useState([])
    const [isCo2Chart,setIsCo2Chart] = useState(false)
    const [trips,setTrips] = useState([])
    const [showSimple,setShowSimple] = useState(false)
    // const [disDef,setDisDef] = useState([])
    const [paginationConfig, setPaginationConfig] = useState({
            current: 1,
            pageSize: 200,
            total: 0, // 初始为0，等数据加载后更新为总条数
            showSizeChanger: false,
            hideOnSinglePage: true,
            showQuickJumper: true
          });

    const currentData = useMemo(() => {
        if (!data || data.length === 0) return [];
        const start = (tableCurrent - 1) * tablePageSize;
        const end = start + tablePageSize;
        let dataIndex = 0;
        let result =[]
        data.some(obj=>{
            if (Array.isArray(obj)){
                obj.some(val=>{
                    if (dataIndex >= start && dataIndex < end) {
                        result.push(val);
                    }
                    dataIndex++;
                    if (dataIndex>end){ 
                        return true
                    }
                })
            }
            
            if (dataIndex>end){
                return true
            }
        })
        return result
    }, [tableCurrent, tablePageSize, data]);
    /**
     * 折线图适应窗口
     */
    const handleResize = useCallback(() =>  {
      setTimeout(()=>{
        showMyChart()
        // myChartP&&myChartP.setOption(option);
        // let heig =state.resolution.height-400
        // myChartP&&myChartP.resize({height:heig});
      },500)
        
    },[])
    const myTimeRanges = {
        今天: [moment().startOf('day'), moment()],
        '本周': [moment().startOf('week'), moment().endOf('week')],
        '本月': [moment().startOf('month'), moment().endOf('month')],
        '上周': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
        '上月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        '前一天': [moment().subtract(1, 'days'), moment()],
        '前三天': [moment().subtract(3, 'days'), moment()],
        '前五天': [moment().subtract(5, 'days'), moment()],
        '前七天': [moment().subtract(5, 'days'), moment()],
        '一小时': [moment().subtract(1, 'hours'), moment()],
        '三小时': [moment().subtract(3, 'hours'), moment()],
        '五小时': [moment().subtract(5, 'hours'), moment()],
        '六小时': [moment().subtract(6, 'hours'), moment()],
    };
    const myDayRanges={
        今天: [moment().startOf('day'), moment()],
        '前一天': [moment().subtract(1, 'days'), moment()],
        '前三天': [moment().subtract(3, 'days'), moment()],
        '前五天': [moment().subtract(5, 'days'), moment()],
        '前七天': [moment().subtract(5, 'days'), moment()],
    };

    /**
     * 时间选择器回调函数
     * @param {}  dates - 时间moment
     * @param {string} dateStrings - 时间字符串
     */
    const handleTimeChange = useCallback((dates, dateStrings) => {

        if (!dates || dates.length === 0) {
            setStartTime('');
            setEndTime('');
            setSelTime(false)
            return;
        }
        setSelTime(true)
        dates[0]!==null&&setStartTime(dateStrings[0]+':00');
        dates[1]!==null&&setEndTime(dateStrings[1]+':59');
    }, []); // 将 tableType 加入依赖项
    // console.trace('⚠️ 图表组件重绘了！');
    useEffect(() => {
        const abortController = new AbortController(); 
        const pageReload = sessionStorage.getItem('reload')
        let isDataPage = props?.isDataPage
        let devDis_ = 0
        if(isDataPage){
            let isMore = props?.showMore
            let sd
            if(isMore){
                sd= state.device.filter(x => x.sn === props.item.Sn&&x.node>0&&!([1].includes(x.hide))&&x.district===props.item.District)
            }else{
                sd= state.device.filter(x => x.sn === props.item.Sn&&x.node===props.item.Node) 
                // if (props.item.Type===218&&props.item.Node%2==0) setIsCo2Chart(true)
            }
            devDis_ = props.item.District
            if (sd.length > 0) {
                
                setSelDevice(sd[0]);
                setUserName(sd[0].user_name);
                setIsHumi(sd[0].humi===0?false:true)
                setSelDevs(sd);
                var nodes = new Array();
                sd.map(m=>{
                    nodes.push(m.node);
                })
                setSelNode(nodes);
                getHisData(sd[0],nodes,sd)
                if(isMore){
                    setShowDevName(sd[0].sn)
                }else{
                    setShowNodeName([sd[0].id])
                    setSelNodeType(sd[0].type);
                }
                
            }
           
            
            // setShowDevName(props?.item)
        }
        
        setIsDataPage(isDataPage)
        if(pageReload==='false'&&Mode==='local'&&!isDataPage){
            sessionStorage.setItem('reload',true)
            window.location.reload(true)
        }
        let today =  new Date().setHours(0,0,0);
        todayTime = new Date(today).getTime();
        http.get("/v1/district", {}).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'district', district: data.data });
            }
        })
        http.get("/v1/users", {}).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'systemuser', systemuser: data.data.sort((a,b)=>a.name.localeCompare(b.name,'zh')) });
            }
        })
        http.get("/v1/userdistricts", {}).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'user_district', user_district: data.data });
            }
        })
        http.get("/v1/device", {}).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'device', device: data.data });
                let arrNode = new Array();
                let arrDev = new Array();
                let data_f = data.data.filter(x=>x.node>0&&!([1].includes(x.hide))).sort((a, b) => a.sn - b.sn)
                data_f.map(m => {
                    arrNode.push({ label: m.name+'-'+m.sn, value: m.id, sn: m.sn ,expire:m.expire,dis:m.district});
                    // arrDev.findIndex(x => x.value === m.sn) === -1&&arrDev.push({ label: m.m_name+'-'+m.sn, value: m.sn ,expire:m.expire,dis:m.district});
                })
                arrDev= Object.values(
                    data_f.reduce((acc, cur) => {
                        // 如果累加器中还没有这个 sn，就初始化一个空数组
                        if (!acc[cur.sn]) {
                          acc[cur.sn] = { value: cur.sn, label:cur.m_name+'-'+cur.sn,expire:cur.expire,dis: [] };
                        }
                        // 使用 Set 进行去重，防止同一个 sn 下出现重复的 dis
                        if (!acc[cur.sn].dis.includes(cur.district)) {
                          acc[cur.sn].dis.push(cur.district);
                        }
                        return acc;
                      }, {})
                  );
                setDevFliters(arrDev);
                setNodeFliters(arrNode);
                if(isDataPage){
                    arrDev = arrDev.filter(x=>x.dis.includes(devDis_) )
                    arrNode = arrNode.filter(x=>x.dis===devDis_ )
                }
                setSelDevOptions(Mode==='soc'?arrDev.filter(x=>new Date(x.expire).getTime()>todayTime):arrDev);
                setSelNodeOptions(Mode==='soc'?arrNode.filter(x=>new Date(x.expire).getTime()>todayTime):arrNode)
            }
        })
        http.get("/v1/devicestatus", {}).then(data => {
            if (data.code === 0) {
              if (data.data !== null) { 
                dispatch_device({ type: 'devicestate', devicestate: data.data });
               }
            }
          })
        window.addEventListener('resize',handleResize)
        return () => {
            setTableKey(Date.now().toString())
            window.removeEventListener('resize',handleResize)
            myChartP&&myChartP.dispose()
            abortController.abort(); 
            setMyChartP()
            setdataChart([]);
            setData([]);
            setSelNodeColums([])
            setSeriesTempData([])
            plotRef.current?.off('element:click'); 
        }
    }, []);
    useEffect(()=>{
        let todo = state.mainTodo;
        let todoCon = todo===''?null:JSON.parse(todo)
        setShowHisModeNew(todoCon?.showHisModeNew?true:false)
        setShowHisLimit(todoCon?.showHisLimit===undefined?true:todoCon.showHisLimit)
    },[state.mainTodo])
    useEffect(()=>{
        myChartP&& myChartP && myChartP.setOption(option);
    },[seriesTempData,showBound,selNodeType])
    //报表查询上午时间选项
    const AMOptions=[
        {label:'0点',value:0},
        {label:'1点',value:1},
        {label:'2点',value:2},
        {label:'3点',value:3},
        {label:'4点',value:4},
        {label:'5点',value:5},
        {label:'6点',value:6},
        {label:'7点',value:7},
        {label:'8点',value:8},
        {label:'9点',value:9},
        {label:'10点',value:10},
        {label:'11点',value:11},
    ];
    //报表查询下午时间选项
    const PMOptions=[
        {label:'12点',value:12},
        {label:'13点',value:13},
        {label:'14点',value:14},
        {label:'15点',value:15},
        {label:'16点',value:16},
        {label:'17点',value:17},
        {label:'18点',value:18},
        {label:'19点',value:19},
        {label:'20点',value:20},
        {label:'21点',value:21},
        {label:'22点',value:22},
        {label:'23点',value:23},
    ]
    const option = useMemo(()=>{
        return  {
            tooltip: tooltip1,
            title: {
                left: 'center',
                text:isHumi?`${userName}\n${startTime}-${endTime}曲线图 \n 温度最小值${dataF.tmin}温度最大值${dataF.tmax}湿度最小值${dataF.hmin}湿度最大值${dataF.hmax}`:`${userName}\n${startTime}-${endTime}曲线图 \n 温度最小值${dataF.tmin}温度最大值${dataF.tmax}`
              },
            legend:{
                top:80,
                type:'scroll',
            },
            // dataset: {
            //     source: dataChart 
            //     // 这里不需要写 dimensions，ECharts 会自动从对象 key 识别
            //     // 除非你需要强制指定顺序或类型（如时间轴类型）
            //   },
            xAxis: {
                type: 'time',
                axisLabel:{
                    formatter:'{HH}:{mm}:{ss} \n {yy}-{MM}-{dd} '
                },
                min:startTime,
                max:endTime
            },
            yAxis: {
                type: 'value',
    
                min: function (value) {
                    return value.min.toFixed(1) - 2;
                },
                max : function (value) {
                    return value.max.toFixed(1) +2;
                },      
                axisLabel:{
                    formatter:function (value, index) {
                        return value.toFixed(1) ;
                    }
                }
            },
            grid:
            {
                left:50,
                right:0,
                bottom:0,
                top:120,
                containLabel:true
            },
            // dataZoom: [
            //   {
            //     type: 'inside',
            //     start: 0,
            //     end: 20
            //   },
            //   {
            //     start: 0,
            //     end: 20
            //   }
            // ],
            series: seriesTempData,
        };
           
    },[tooltip1,isHumi,userName,startTime,endTime,dataF,seriesTempData])
       
    const configtemp = 
        {
            data: dataChart,
            tooltip:tooltip,
            padding: 'auto',
            xField: 'data_time',
            autoFit:true,
            yField: 'temp',
            seriesField: 'name',
            yAxis: {
                label: {
                    formatter: function formatter(v) {
                        var i = v.indexOf('.');
                        return i===-1?v:v.slice(0,i+2);
                    },
                },
                max:(dataF.tmax> dataWainF.th)?dataF.tmax+2:dataWainF.th+2,
                min:dataWainF.tl<dataF.tmin?dataWainF.tl-2:dataF.tmin-2,
            },
            xAxis: {
                label:{
                  offset:20
              }
            },
            slider: {
                start: 0,
                end:1,
                padding: [10, 10, 0, 10], // 尝试给右侧或左侧增加 padding
                backgroundStyle:{
                    fill: 'white',
                    fillOpacity: 0,
                    columnStyle: {
                        fill: 'white',
                        fillOpacity: 0,
                    }
                },
                foregroundStyle:{
                    fill: 'white',
                    fillOpacity: 0,
                },
                trendCfg:{
                    lineStyle:{stroke:'white'}
                }
            },
            annotations:showBound?showBoundWarnT? [
                {
                    type: 'line',
                    start: ['start',dataWainF.th],
                    end:['end',dataWainF.th],
                    style: {
                      stroke: '#F4664A',
                      lineDash: [5, 4],
                    },
                },
                {
                    type: 'text',
                    position: ['min', dataWainF.th],
                    content: `${dataWainF.th+(selNodeType===205?'Pa':(selNodeType===210||selNodeType===211)?'MPa':'℃')}(上)`,
                    offsetY: -4,
                    offsetX:-14,
                    style: {
                      textBaseline: 'bottom',
                    },
                },
                {
                    type: 'line',
                    start: ['start',dataWarnT.th],
                    end:['end',dataWarnT.th],
                    style: {
                      stroke: '#FFA500',
                      lineDash: [8, 4],
                    },
                },
                {
                    type: 'text',
                    position: ['min', dataWarnT.th],
                    content: `${dataWarnT.th+(selNodeType===205?'Pa':(selNodeType===210||selNodeType===211)?'MPa':'℃')}(上)`,
                    offsetY: -4,
                    offsetX:-14,
                    style: {
                      textBaseline: 'bottom',
                    },
                },
                {
                    type: 'line',
                    start: ['start',dataWainF.tl],
                    end:['end',dataWainF.tl],
                    style: {
                      stroke: '#F4664A',
                      lineDash: [5, 4],
                    },
                },
                {
                    type: 'text',
                    position: ['min', dataWainF.tl],
                    content: `${dataWainF.tl+(selNodeType===205?'Pa':(selNodeType===210||selNodeType===211)?'MPa':'℃')}(下)`,
                    offsetY: 18,
                    offsetX:-14,
                    style: {
                      textBaseline: 'bottom',
                    },
                },
                {
                    type: 'line',
                    start: ['start',dataWarnT.tl],
                    end:['end',dataWarnT.tl],
                    style: {
                      stroke: '#FFA500',
                      lineDash: [8, 4],
                    },
                },
                {
                    type: 'text',
                    position: ['min', dataWarnT.tl],
                    content: `${dataWarnT.tl+(selNodeType===205?'Pa':(selNodeType===210||selNodeType===211)?'MPa':'℃')}(下)`,
                    offsetY: -4,
                    offsetX:-14,
                    style: {
                      textBaseline: 'bottom',
                    },
                },
            ]:[
                {
                    type: 'line',
                    start: ['start',dataWainF.th],
                    end:['end',dataWainF.th],
                    style: {
                      stroke: '#F4664A',
                      lineDash: [5, 4],
                    },
                },
                {
                    type: 'text',
                    position: ['min', dataWainF.th],
                    content: `${dataWainF.th+(selNodeType===205?'Pa':(selNodeType===210||selNodeType===211)?'MPa':'℃')}(上)`,
                    offsetY: -4,
                    offsetX:-14,
                    style: {
                      textBaseline: 'bottom',
                    },
                },
                {
                    type: 'line',
                    start: ['start',dataWainF.tl],
                    end:['end',dataWainF.tl],
                    style: {
                      stroke: '#F4664A',
                      lineDash: [5, 4],
                    },
                },
                {
                    type: 'text',
                    position: ['min', dataWainF.tl],
                    content: `${dataWainF.tl+(selNodeType===205?'Pa':(selNodeType===210||selNodeType===211)?'MPa':'℃')}(下)`,
                    offsetY: 18,
                    offsetX:-14,
                    style: {
                      textBaseline: 'bottom',
                    },
                },
            ]:[],
            // color: '#D62A0D',
            color: ['#00bc12','#D62A0D', '#9900FF', '#000000','#335541','#656485','#784512','#255454','#621532','#785423','#996655','#996699','#9999CC','#99CC99','#99FFFF'],
        }
    ;
    const configco2 = 
    {
        data: co2Datas,
        tooltip:tooltip,
        padding: 'auto',
        xField: 'data_time',
        autoFit:true,
        yField: 'co2',
        seriesField: 'name',
        // yAxis: {
        //     label: {
        //         formatter: function formatter(v) {
        //             var i = v.indexOf('.');
        //             return i===-1?v:v.slice(0,i+2);
        //         },
        //     },
        //     max:(dataF.tmax> dataWainF.th)?dataF.tmax+2:dataWainF.th+2,
        //     min:dataWainF.tl<dataF.tmin?dataWainF.tl-2:dataF.tmin-2,
        // },
        xAxis: {
            label:{
              offset:20
          }
        },
        slider: {
            start: 0,
            end:1,
            padding: [10, 10, 0, 10], // 尝试给右侧或左侧增加 padding
            backgroundStyle:{
                fill: 'white',
                fillOpacity: 0,
                columnStyle: {
                    fill: 'white',
                    fillOpacity: 0,
                }
            },
            foregroundStyle:{
                fill: 'white',
                fillOpacity: 0,
            },
            trendCfg:{
                lineStyle:{stroke:'white'}
            }
        },

        // color: '#D62A0D',
        color: ['#00bc12','#D62A0D', '#9900FF', '#000000','#335541','#656485','#784512','#255454','#621532','#785423','#996655','#996699','#9999CC','#99CC99','#99FFFF'],
    }
;
    const confighumi = {
        data: dataChart,
        tooltip:tooltip,
        padding: 'auto',
        xField: 'data_time',
        // height: 200,
        autoFit:true,
        yField: 'humi',
        seriesField: 'name',
        yAxis: {
            label: {
                formatter: function formatter(v) {
                    var i = v.indexOf('.');
                    return i===-1?v:v.slice(0,i+2);
                },
            },
            // tickCount:10
            max:(dataWainF.hh>dataF.hmax)?(dataWainF.hh>97?100:dataWainF.hh+2):(dataF.hmax>97?100:dataF.hmax+2),
            min:(dataWainF.hl<dataF.hmin)?(dataWainF.hl<3?0:dataWainF.hl-2):(dataF.hmin<3?0:dataF.hmin-2),
        },
        xAxis: {
            label: {
                offset:20
            },
        },
        slider: {
            start: 0,
            end:1,
            backgroundStyle:{
                fill: 'white',
                fillOpacity: 0,
                columnStyle: {
                    fill: 'white',
                    fillOpacity: 0,
                }
            },
            foregroundStyle:{
                fill: 'white',
                fillOpacity: 0,
            },
            trendCfg:{
                lineStyle:{stroke:'white'}
            }
        },
        annotations: showBound?showBoundWarnH?[
            {
                type: 'line',
                start: ['start',dataWainF.hh],
                end:['end',dataWainF.hh],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.hh],
                content: dataWainF.hh+'(上)',
                offsetY: -4,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWarnH.hh],
                end:['end',dataWarnH.hh],
                style: {
                  stroke: '#FFA500',
                  lineDash: [8, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWarnH.hh],
                content: dataWarnH.hh+'(上)',
                offsetY: -4,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWainF.hl],
                end:['end',dataWainF.hl],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.hl],
                content: dataWainF.hl+'(下)',
                offsetY: 18,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWarnH.hl],
                end:['end',dataWarnH.hl],
                style: {
                  stroke: '#FFA500',
                  lineDash: [8, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWarnH.hl],
                content: dataWarnH.hl+'(下)',
                offsetY: -4,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
        ]:[
            {
                type: 'line',
                start: ['start',dataWainF.hh],
                end:['end',dataWainF.hh],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.hh],
                content: dataWainF.hh+'(上)',
                offsetY: -4,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWainF.hl],
                end:['end',dataWainF.hl],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.hl],
                content: dataWainF.hl+'(下)',
                offsetY: 18,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
        ]:[]
        ,
        // color: '#1979C9',
    };
    const columnsLeft = [
        {
            title:'记录条数:'+recordCount,
            children:[
                {
                    title: '时间',
                    dataIndex: 'data_time',
                    align: 'center  ',
                    width: 160,
                    fixed: true,
                    sorter: (a, b) =>new Date(a.data_time).getTime()  -new Date(b.data_time).getTime() ,
                    render:(text, record) =>  {
                        if(record.type===209){
                            if(record.gps_dir===1){
                                return `${text} 开始`
                            }else if(record.gps_dir===2){
                                return`${text} 结束`
                            }else{
                                return text
                            }
                        }else{
                            return text
                        }
                    }
                }
            ]
        }
    ]
    const userdistrict = useMemo(()=>{
        if (state.district.length===0) return[]
        let userdistrictlist = new Array()
        if (Mode==='soc') {
            //登录用户是普通用户
            if(state.main.type===104){
                userdistrictlist = new Array()
                const ud = state.district;
                ud.map(item => {
                    var u = new Object;
                    u.key = item.id;
                    u.title = item.name;
                    u.label = item.name;
                    u.text = item.name;
                    u.value =item.id;
                    u.name = item.name;
                    // u.id = item.id
                    userdistrictlist.unshift(u);
                })
            }else if(state.systemuser.treeM){
                userdistrictlist = JSON.parse(JSON.stringify(state.systemuser.treeM));
                if (userdistrictlist && userdistrictlist.length > 0) {
                    addUserDistrict(userdistrictlist);
                } 
            }
        }
        if (Mode!=='soc' && state.district) {
            userdistrictlist = new Array();
            state.district.map(item => {
                var u = new Object;
                u.key = item.id;
                u.title = item.name;
                u.label = item.name;
                u.text = item.name;
                u.value = item.id;
                u.name = item.name;
                // u.id = item.id
                userdistrictlist.push(u);
            })
        }
        return userdistrictlist
    },[state.district,state.systemuser.treeM]);
    const disDef = useMemo(()=>{
        if(!isDataPage||state.district.length===0) return[]
        let userDis =[]
        let devDis = state.district.filter(x=>x.id===props.item.District)
        if(devDis.length>0){
            if(Mode==='soc'){
                let parentName = [];
                getparent(state.systemuser.list,devDis[0].user,parentName)
                parentName.map(m=>{
                    userDis.unshift(m)
                })
                userDis.push('dis'+devDis[0].id)
            }else{
                userDis = devDis[0].id
            }
            
        }
        return userDis
    },[state.district,isDataPage])
    useEffect(()=>{
        setSelDis(disDef)
    },[disDef])
    function addUserDistrict(userlist) {
        for (var i = 0; i < userlist.length; i++) {
            if (!userlist[i].children) {
                let ud=[];
                userlist[i].id&& (ud = state.district.filter(x => x.user == userlist[i].id));//筛查userlist[i]创建的所有区域
                if (ud.length > 0) {
                    userlist[i].children = [];
                    ud.map(item => {
                        var u = new Object;
                        u.key = item.id;
                        u.title = item.name;
                        u.label = item.name;
                        u.text = item.name;
                        u.value = 'dis'+item.id;
                        u.name = item.name;
                        userlist[i].children.unshift(u);
                    })
                }
                else{
                    userlist[i].id&&(userlist.splice(i,1));
                    // userlist[i].id&&(userlist[i].disabled=true);
                }
            } else {
                let ud=[];
                userlist[i].id&& (ud = state.district.filter(x => x.user == userlist[i].id));//筛查userlist[i]创建的所有区域
                if (ud.length > 0) {
                    ud.map(item => {
                        var u = new Object;
                        u.key = item.id;
                        u.title = item.name;
                        u.label = item.name;
                        u.text = item.name;
                        u.value = 'dis'+item.id;
                        u.name = item.name;
                        // u.id = item.id
                        userlist[i].children.unshift(u);
                    })
                }
                addUserDistrict(userlist[i].children);
            }
        }
    }
    function runBatchTasks(tasks, batchSize = 5) {
        const results = [];
        
        // 使用 async/await 循环来处理“串行中的并发”
        return (async () => {
          for (let i = 0; i < tasks.length; i += batchSize) {
            // 1. 截取当前批次的任务
            const batch = tasks.slice(i, i + batchSize);
            
            // 2. 等待当前批次全部完成
            const batchResults = await Promise.all(batch);
            batchResults.map(res => {
                // 根据你的实际返回结构调整，这里假设 res.data 就是列表数组
                const keys = Object.keys(res.data.history);
                const dataF =[]
                for (let i = 0; i < keys.length; i++) {//遍历所有时间
                    let key = keys[i];
                    let dataTemp = res.data.history[key];//相同时间的测点数据数组
                    if(dataTemp.length>0){
                        let dataTempF = dataTemp[0];//获取数组内的第一个测点数据
                        // let dataTempF = {};//新建一个对象
                        dataTemp.map(m=>{ 
                            const nodeSuffix = m.node;
                            const fields = {
                                temp: m.temp,
                                temp_h: m.temp_h,
                                temp_l: m.temp_l,
                                temp_alarm: m.temp_alarm,
                                temp_switch: m.temp_switch,
                                humi: m.humi,
                                humi_h: m.humi_h,
                                humi_l: m.humi_l,
                                humi_alarm: m.humi_alarm,
                                humi_switch: m.humi_switch,
                                humi_enable: m.humi_enable,
                                door: m.door,
                                power: m.power,
                                battery: m.battery
                            };
    
                            Object.entries(fields).forEach(([key, val]) => {
                                dataTempF[`${key}${nodeSuffix}`] = val;
                            });
                            })
                        dataF.push(dataTempF)
                    }
                }
                results.push(...dataF)
              });
              
            // 3. 将结果合并到大数组中
            // results.push(...batchResults);
            
            // 可选：打印进度
            console.log(`进度: ${Math.min(i + batchSize, tasks.length)} / ${tasks.length}`);
            
          }
          
          return results;
        })();
      }
    const getHisByPage =async  (nodes,starttime, endtime,page,unitName,newmodel=false,showLimit=false) => { 
        let url = "/v1";   
            url += "/history_page?device=" + selDevice.sn + "&node=" + nodes + "&starttime=" ;
            url+=starttime+"&endtime=" + endtime+"&page="+page+"&pagesize="+200;
            setLoading(true);
            setIsHumi(false);
            let dataStatistics={tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 };
            await http.get(url,{}).then((data) => {
                setData([])
                setLoading(false);
                setIsHumi(false);
                let is_Humi = false;
                if (data.code === 0) {
                    if (data.data.history===null||data.data.history?.length === 0) {
                        return message.warning('暂无数据')
                    };
                    
                    // let checkData = data.data.history[0];
                    const keys = Object.keys(data.data.history);
                    setPaginationConfig(prev => ({
                        ...prev,
                        current: page,
                        pageSize:keys.length ,
                        total:data.data.total, // 使用API返回的总数据量
                        }));
                        
                        
                    if(keys.length===0) return;
                    let checkData = data.data.history[keys[0]][0];
                    if(checkData.node===0){
                        checkData= data.data.history[keys[0]][1];
                    }
                    if(checkData.humi_switch!==0&&checkData.humi_enable!==0){
                        setIsHumi(true);
                        is_Humi = true;
                    }
                    let dataF =[]
                    
                    for (let i = 0; i < keys.length; i++) {//遍历所有时间
                        let key = keys[i];
                        let dataTemp = data.data.history[key];//相同时间的测点数据数组
                        if(dataTemp.length>0){
                            let dataTempF = dataTemp[0];//获取数组内的第一个测点数据
                            // let dataTempF = {};//新建一个对象
                            dataTemp.map(m=>{ 
                                const nodeSuffix = m.node;
                                const fields = {
                                    temp: m.temp,
                                    temp_h: m.temp_h,
                                    temp_l: m.temp_l,
                                    temp_alarm: m.temp_alarm,
                                    temp_switch: m.temp_switch,
                                    humi: m.humi,
                                    humi_h: m.humi_h,
                                    humi_l: m.humi_l,
                                    humi_alarm: m.humi_alarm,
                                    humi_switch: m.humi_switch,
                                    humi_enable: m.humi_enable,
                                    door: m.door,
                                    power: m.power,
                                    battery: m.battery
                                };
        
                                Object.entries(fields).forEach(([key, val]) => {
                                    dataTempF[`${key}${nodeSuffix}`] = val;
                                });
                                })
                            dataF.push(dataTempF)
                        }
                    }

                    // var artemp= dataF.filter(item => item.temp !== 102.3 && item.temp !== 102.2 &&item.temp_switch!==0&&item.temp !== -102.3 && item.temp !== -102.2);
                    // if(is_Humi){
                    //     artemp= artemp.filter(item => item.humi !== -102.2&&item.humi !== -102.3&&item.humi !== 102.3 && item.humi !== 102.2);
                    // }
                    // let ar = JSON.parse(JSON.stringify(artemp));
                    // var arLen = ar.length;
                    setData(dataF);
                    setRecordCount(dataF.length+'');
                    let columns = [
                        {
                            title:'记录条数:'+data.data.total,
                            children:[
                                {
                                    title: '时间',
                                    dataIndex: 'data_time',
                                    align: 'center',
                                    width:160,
                                    sorter: (a, b) =>new Date(a.data_time).getTime()  -new Date(b.data_time).getTime() ,
                                }
                            ]
                            
                        },
                    ];
                    if(nodes.length>1){
                        selDevs.map(({ node, name, district_name, m_name,door_alarm ,type,humi}) => {
                            if (node!==0){
                                let obj ={
                                    title: `${name}-(区域:${district_name}-主机:${m_name}-测点ID:${node})`,
                                    align: 'center',
                                    children: [
                                        {
                                            title: '温度(℃)',
                                            dataIndex: 'temp' + node,
                                            align: 'center',
                                            width:100,
                                            render: (text, record) => (
                                                <div>
                                                    <div style={{color:record['temp_alarm' + node] === 1 ?'red':''}}>{ record['temp_switch' + node] === 0 ? "--" : text?
                                                    (text === 102.2||text === 102.3||text === -102.2||text === -102.3) ? " NL" :text.toFixed(1):''}</div>
                                                </div>
                                            )
                                        },
                                        {
                                            title: '状态',
                                            dataIndex: 'temp_alarm' + node,
                                            align: 'center',
                                            width: 60,
                                            render: (text, record) => (
                                                <div style={{color:text === 1 ?'red':''}}>{record['temp_switch' + node] === 0 ? "--" :text === 0 ? '正常' :text === 1 ? '报警':null}</div>
                                            )
                                        },
                                    ]
                                }
                                if (humi!==0){
                                    obj.children.push(
                                    {
                                        title: '湿度(%RH)',
                                        dataIndex: 'humi' + node,
                                        align: 'center',
                                        width: 100,
                                        render: (text, record) => (
                                            <div>
                                                <div style={{color:record['humi_alarm' + node] === 1 ?'red':''}}>{ record['humi_switch' + node] === 0 ? "--" : record['humi_enable' + node]===0 ?"--":
                                                (text === 102.2||text === 102.3||text === -102.2||text === -102.3) ? " NL" : text?text.toFixed(1):''}</div>
                                            </div>
                                        )
                                    },
                                    {
                                        title: '状态',
                                        dataIndex: 'humi_alarm' + node,
                                        width: 60,
                                        align: 'center',
                                        render: (text, record) => (
                                            <div style={{color:text === 1 ?'red':''}}>{record['humi_switch' + node] === 0 ? "--" : record['humi_enable' + node]===0 ?"--" :text === 0 ? '正常' : text === 1 ? '报警':''}</div>
                                        )
                                    },)
                                }
                                if(type===214&&door_alarm===1){
                                    obj.children.push( {
                                        title: '门状态',
                                        align: 'center',
                                        dataIndex:'door'+node,
                                        width:80,
                                        render:(text,record)=>{
                                            return <div style={{color:text===1?'red':'black'}}>{text===1?'门开启':text===0?'门关闭':''}</div>
                                        }
                                    })
                                }
                                if(type===214||type===208){
                                    obj.children.push( 
                                    {
                                        title: '电量',
                                        align: 'center',
                                        width:60,
                                        dataIndex:'battery'+node
                                    }
                                )}
                                columns.push(obj)   
                            }else{
                                door_alarm===1 &&
                                columns.push({
                                    title: '门状态',
                                    dataIndex: 'door' + node,
                                    width: 100,
                                    align: 'center',
                                    render: (text, record) => (
                                        <div>
                                            <div>{record['door' + node]  === 0 ? "关门" : '开门'}</div>
                                        </div>
                                    )
                                })
                            }
                        })
                    }
                    if(nodes.length===1){
                        if(selDevice.node===0){
                            selDevice.door_alarm===1&&
                            columns.push(
                                {
                                    title: '开关门',
                                    dataIndex: 'door',
                                    align: 'center',
                                    render: (text, record) => 
                                        <div>
                                            <div>{record.door===0?'关门':'开门'}</div>
                                        </div>
                                }
                            )
                        }else{
                            columns.push(
                                {
                                    title:showUnitName+`  (最大:${selDevice.type===211?dataStatistics.tmax.toFixed(2):dataStatistics.tmax.toFixed(1)} 
                                    最小:${selDevice.type===211?dataStatistics.tmin.toFixed(2):dataStatistics.tmin.toFixed(1)} 
                                    平均:${dataStatistics.tavg.toFixed(1)})`,
                                    children:[
                                        {
                                            title: `记录值(${showUnit})`,
                                            align: 'center',
                                            render: (text, record) => (
                                                <span style={{color:record.temp_alarm === 1 ?'red':''}}>{record.temp_switch===0?'--':
                                                    (record.temp===102.2||record.temp===102.3||record.temp===-102.2||record.temp===-102.3)?'NL':record.type===211?record.temp.toFixed(2):record.temp.toFixed(1)}</span>
                                            ),
                                        },
                                        {
                                            title: '状态',
                                            align: 'center',
                                            render: (text, record) => (
                                                <div style={{color:record.temp_alarm === 1 ?'red':''}}>{record.temp_switch===0?'停用':record.temp_alarm === 1 ? '报警' : '正常'}</div>
                                            ),
    
                                        },
                                    ],
                                }
                            )
                            if(is_Humi){
                                columns.push(
                                    {
                                        title:'湿度'+`  (最大:${dataStatistics.hmax.toFixed(1)} 
                                        最小:${dataStatistics.hmin.toFixed(1)} 
                                        平均:${dataStatistics.havg.toFixed(1)})`,
                                        children:[
                
                                            {
                                                title:'记录值(%RH)',
                                                align: 'center',
                                                render: (text, record) => 
                                                    <div style={{color:record.humi_alarm === 1 ?'red':''}}>{record.humi_switch===0?'--':
                                                        (record.humi===102.2||record.humi===102.3||record.humi===-102.2||record.humi===-102.3)?'NL':record.humi.toFixed(1)}</div>                           
                                            },
                                            
                                            {
                                                title:'状态',
                                                align: 'center',
                                                render: (text, record) => 
                                                    <div style={{color:record.humi_alarm === 1 ?'red':''}}>{record.humi_switch===0?'停用':record.humi_alarm === 1 ? '报警' :record['humi_alarm'] === 0 ? '正常':null}</div>
                                            },
                                        ],
                                    },
                                )
                            }
                        }
                    }
                    if(selDevice.type!==214){
                        columns.push(
                            {
                                title: '信号',
                                dataIndex: 'csq',
                                width: 80,
                                align: 'center',
                            },
                        )
                    }else{
                        if(selDevice.node!==0&&selDevice.door_alarm===1){
                            columns.push(
                            {
                                title: '门状态',
                                dataIndex:  'door',
                                align: 'center',
                                width: 80,
                                render:(text,record)=>(
                                    <div style={{color:text===1?'red':'black'}}>{record.door === 0?"门关闭":"门开启"}</div>
                                )
                            }
                            )
                        }
                    }
                    if(selDevice.type===209&&selDevice.door_alarm===1){
                        columns.push(
                            {
                                title: '门状态',
                                dataIndex: 'door',
                                width: 100,
                                align: 'center',
                                render:(text,record)=>(
                                    <div style={{color:text===1?'red':'black'}}>{record.door === 0?"关闭":"开启"}</div>
                                )
                            },
                        )
                    }
                    columns.push(
                        {
                            title: '电源',
                            dataIndex:  'power',
                            align: 'center',
                            width: 80,
                            render:(text,record)=>(
                                <div>{record.power === 0?"正常":"电池"}</div>
                            )
                        },
                        {
                            title: '电量',
                            width: 80,
                            dataIndex: 'battery',
                            align: 'center',
                        }
                    )
                    setSelNodeColums(columns)
                    if (page===1){
                        let totalPages = Math.ceil(data.data.total/keys.length)
                        url = "/v1";   
                        url += "/history_page?device=" + selDevice.sn + "&node=" + nodes + "&starttime="+starttime+"&endtime=" + endtime ;
                        const tasks = [];
                        for (let page = 2; page <= totalPages; page++) {
                            let geturl=url+"&page="+page+"&pagesize="+200;
                            tasks.push(
                                http.get(geturl, {})
                            );
                        }
                        setTimeout(() => {
                            runBatchTasks(tasks, 5).then(otherPagesData => {
                                // 第四步：整合数据
                                // 把第一页的数据放在最前面，后面接上其他页的数据
                                // return [dataF, ...otherPagesData].flat();
                                dataF = [dataF, ...otherPagesData].flat();
                                var artemp= dataF.filter(item => item.temp !== 102.3 && item.temp !== 102.2 &&item.temp_switch!==0&&item.temp !== -102.3 && item.temp !== -102.2);
                                if(is_Humi){
                                    artemp= artemp.filter(item => item.humi !== -102.2&&item.humi !== -102.3&&item.humi !== 102.3 && item.humi !== 102.2);
                                }
                                let ar = JSON.parse(JSON.stringify(artemp));
                                var arLen = ar.length;
                                if(selDevice.node>0) {
                                    if (arLen === 0 ) return message.warning('暂无有效数据');
                                    let tH = selDevice.temp_alarm_high;
                                    let tL = selDevice.temp_alarm_low;
                                    let hH = selDevice.humi_alarm_high;
                                    let hL = selDevice.humi_alarm_low;
                                    if(selDevice.hide===2||selDevice.hide===3){
                                        setShowBound(false)
                                        setDataWainF({th:dataStatistics.tmax,tl:dataStatistics.tmin,hh:dataStatistics.hmax,hl:dataStatistics.hmin});
                                    }else{
                                        setDataWainF({th:tH,tl:tL,hh:hH,hl:hL});
                                    }
                                    let maxNum = ar.length;
                                    let normalData = [];
                                    let warnData=[];
                                    let start ;let end;
                                    let seriesData=[]
                                    let tempdata =[];
                                    let humidata =[];
                                    let name ='';
                                    ar.map(val=>{
                                        tempdata.push([val.data_time,val.temp]);
                                        humidata.push([val.data_time,val.humi]);
                                        if(name==='' ){
                                            name =val.name
                                        }
                                    })
                                    ar[0].data_time!==startTime&&tempdata.unshift(null);
                                    ar[ar.length-1].data_time!==endTime&&tempdata.push(null);
                                    seriesData.push({
                                        name:name+(unitName?unitName:showUnitName)+'曲线',
                                        type: 'line',
                                        smooth: true,
                                        symbol: 'none',
                                        encode: {
                                            x: 'data_time',
                                            y: 'humi'
                                          }
                                        // data: tempdata,
                                    })
                                    is_Humi&&seriesData.push({
                                        name:name+'湿度曲线',
                                        type: 'line',
                                        smooth: true,
                                        symbol: 'none',
                                        encode: {
                                            x: 'data_time',
                                            y: 'humi'
                                          }
                                        // data: humidata,
                                    })
                                    setSeriesTempData(seriesData);
                                    if(maxNum<20000){
                                        warnData=ar;
                                    }
                                    if(maxNum>20000&&maxNum<=50000){
                                        ar.map(m=>{
                                            if(m.temp_alarm===1||m.humi_alarm===1){
                                                warnData.push(m)
                                            }else{
                                                normalData.push(m)
                                            }
                                        })
                                        normalData.map((m,i)=>{
                                            i%2==0&&warnData.push(m);
                                        })
                                        warnData.sort((a,b)=>{
                                            const timeA = new Date(a.data_time).getTime() || 0;
                                            const timeB = new Date(b.data_time).getTime() || 0;
                                            return timeA - timeB;
                                        });
                                    }
                                    if(maxNum>50000&&maxNum<=100000){
                                        ar.map(m=>{
                                            if(m.temp_alarm===1||m.humi_alarm===1){
                                                warnData.push(m)
                                            }else{
                                                normalData.push(m)
                                            }
                                        })
                                        normalData.map((m,i)=>{
                                            i%3==0&&warnData.push(m);
                                        })
                                        warnData.sort((a,b)=>{
                                            const timeA = new Date(a.data_time).getTime() || 0;
                                            const timeB = new Date(b.data_time).getTime() || 0;
                                            return timeA - timeB;
                                        });
                                        
                                    }
                                    if(maxNum>100000&&maxNum<=200000){
                                        ar.map(m=>{
                                            if(m.temp_alarm===1||m.humi_alarm===1){
                                                warnData.push(m)
                                            }else{
                                                normalData.push(m)
                                            }
                                        })
                                        normalData.map((m,i)=>{
                                            i%6==0&&warnData.push(m);
                                        })
                                        warnData.sort((a,b)=>{
                                            const timeA = new Date(a.data_time).getTime() || 0;
                                            const timeB = new Date(b.data_time).getTime() || 0;
                                            return timeA - timeB;
                                        });
                                    }
                                    if(maxNum>200000){
                                        ar.map(m=>{
                                            if(m.temp_alarm===1||m.humi_alarm===1){
                                                warnData.push(m)
                                            }else{
                                                normalData.push(m)
                                            }
                                        })
                                        normalData.map((m,i)=>{
                                            i%10==0&&warnData.push(m);
                                        })
                                        warnData.sort((a,b)=>{
                                            const timeA = new Date(a.data_time).getTime() || 0;
                                            const timeB = new Date(b.data_time).getTime() || 0;
                                            return timeA - timeB;
                                        });
                                    }
                                    start =  warnData[0];
                                    end = warnData[warnData.length-1];
                                    start.data_time!==starttime&&warnData.unshift({data_time:starttime,temp:null});
                                    end.data_time!==endtime&&warnData.push({data_time:endtime,temp:null});
                                    setdataChart(warnData);
                                }
                              });
                        }, 1000);
                    }
                }
            })
    }
    const handleTableChange = (newPagination, filters, sorter) => {
        getHisByPage(selNode,startTime,endTime, newPagination.current,showUnitName);
    };
    const showMyChart = (val='',title='',tooltip={trigger: 'axis'})   =>{
        myChartP&&myChartP.dispose()
        setTimeout(() => {
            setMyChartP()
            let chartDom = document.getElementById('tempEcharts');
            if(chartDom){
                let myChart = echarts.init(chartDom);
                setMyChartP(myChart)
                if(val!==''){
                    option.series = val
                    option.title = title
                }
                option.tooltip= tooltip
                option && myChart.setOption(option);
                myChart.resize();
                myChart&&myChart.dispatchAction({
                    type: 'legendScroll',
                    scrollDataIndex: 5,
                    // legendId: string
                })
            }    
        }, 100);
    }
    const onChange_Tab = key => {
        setTabKey(key)
        if (key==='2'){
            showMyChart('','',tooltip1)
        }
        // if(key!=='1'){
        //     myChartP&&myChartP.setOption(option);
        //     let heig =state.resolution.height-400
        //     myChartP&&myChartP.resize({height:heig});
        // }
    };
    const onChange_Table = (page,pageSize) =>{
        setTableCurrent(page)
        setTablePageSize(pageSize)
    }
    const plotRef = React.useRef(null);
    const handleReady = (plot) => {
        // 保存 plot 实例到 ref
        plotRef.current = plot;
    
        // 定义事件处理函数
        const handleClick = (args) => {
            const {x, y} = args;
            let points = args.data.points;
            points = points.reverse();
            let ele = points.reduce((prec, cur) => {
                let xLen = Math.abs(prec.x - x);
                let xLen1 = Math.abs(cur.x - x);
                let yLen = Math.abs(prec.y - y);
                let yLen1 = Math.abs(cur.y - y);
                if(Math.sqrt(xLen*xLen + yLen*yLen) < Math.sqrt(xLen1*xLen1 + yLen1*yLen1)){
                    return prec;
                } else {
                    return cur;
                }
            });
            let index = points.findIndex(val => val.x === ele.x && val.y === ele.y);
            setTabKey('1');
            setTableCurrent(Math.ceil(index / tablePageSize));
        };
    
        // 绑定事件
        plot.on('element:click', handleClick);
      };

    const myTableCol= useMemo(()=>{
        let  nodeCol = new Array();
        const devNodeMap = {};
        if(!showSimple){
            let dev_val =[...selDevSt];
            dev_val.forEach(item => {
                if (!devNodeMap[item.node]) {
                    devNodeMap[item.node] = [];
                }
                devNodeMap[item.node].push(item);
            });
        }
        let sd = [...selDevs];
        if(sd.length>1){
            sd.sort((a,b)=>a.node-b.node);
            if(sd[0].node===0){
                let temp = sd.splice(0,1);
                sd.push(temp[0]);
            }
        }
        if(showSimple){
            sd.map(({ node, name, district_name, m_name,id,door_alarm ,type,humi}) => {
                if (node!==0){
                    let titleName = '温度'
                    let obj ={
                        title: `${name}`,
                        align: 'center',
                        children: [
                           
                        ]
                    }


                    let tempobj = {
                        title: titleName,
                        dataIndex: 'temp' + node,
                        align: 'center',
                        width:60,
                        render: (text, record) =>  {
                            // 1. 卫语句：处理开关关闭的情况
                            if (record['temp_switch' + node] === 0) {
                                return <div>--</div>;
                            }
                        
                            // 2. 核心逻辑优化
                            // 原始代码中：text ? ... : ''
                            // 隐患：如果 text 为 0，会被判定为 false，导致显示为空字符串，而不是 "0.0"
                            if (text === undefined || text === null) {
                                return <div></div>;
                            }
                        
                            // 3. 特殊值判断与渲染
                            // 使用 toFixed 前必须确保 text 是数字类型
                            const isSpecialValue = [102.2, 102.3, -102.2, -102.3].includes(text);
                            let displayText = isSpecialValue ? " NL" : Number(text).toFixed(1);
    
                            // 4. 颜色控制
                            const color = record['temp_alarm' + node] === 1 ? 'red' : undefined;
                        
                            return (
                                <div style={{ color }}>
                                    {displayText}
                                </div>
                            );
                        }
                            
                    }
                    let dataIndexN = 'temp'
                    if(type===218&&node%2===0){
                        titleName='CO2'
                        dataIndexN= 'co2'
                        tempobj = {
                            title: titleName,
                            dataIndex: 'co2' + node,
                            align: 'center',
                            width:60,
                            render: (text, record) =>  {
                                // 1. 卫语句：处理开关关闭的情况
                                if (record['co2_switch' + node] === 0) {
                                    return <div>--</div>;
                                }  
                                // 2. 核心逻辑优化
                                // 原始代码中：text ? ... : ''
                                // 隐患：如果 text 为 0，会被判定为 false，导致显示为空字符串，而不是 "0.0"
                                if (text === undefined || text === null) {
                                    return <div></div>;
                                }
                            
                                // 3. 特殊值判断与渲染
                                // 使用 toFixed 前必须确保 text 是数字类型
                                const isSpecialValue = [102.2, 102.3, -102.2, -102.3].includes(text);
                                let displayText = isSpecialValue ? " NL" : parseInt(text);
                                // 4. 颜色控制
                                const color = record['co2_alarm' + node] === 1 ? 'red' : undefined;
                            
                                return (
                                    <div style={{ color }}>
                                        {displayText}
                                    </div>
                                );
                            }
                                
                        }
                    }

                    obj.children.push(
                        tempobj
                    )

                    if (humi!==0){

                        obj.children.push(
                            {
                                title: '湿度',
                                dataIndex: 'humi' + node,
                                align: 'center',
                                width: 60,
                                render:(text,record)=>( 
                                    <HumidityCell 
                                        text={text} 
                                        record={record} 
                                        node={node}    // 把 node 作为 props 传进去
                                        name={'湿度'}    // 把模式传进去
                                    />)
                            }
                        )
                    }
                    if(type===214 &&door_alarm===1){
                        obj.children.push( {
                            title: '门状态',
                            align: 'center',
                            dataIndex:'door'+node,
                            width:80,
                            render:(text,record)=>{
                                return <div style={{color:text===1?'red':'black'}}>{text===1?'门开启':text===0?'门关闭':''}</div>
                            }
                        })
                    }
                    if(type===214||type===208){
                        obj.children.push( 
                        {
                            title: '电量',
                            align: 'center',
                            width:60,
                            dataIndex:'battery'+node
                        }
                    )}
                    nodeCol.push(obj)   
                }else{
                    door_alarm===1 &&
                    nodeCol.push({
                        title: '门状态',
                        dataIndex: 'door' + node,
                        width: 100,
                        align: 'center',
                        render: (text, record) => (
                            <div>
                                <div>{record['door' + node]  === 0 ? "关门" : '开门'}</div>
                            </div>
                        )
                    })
                }
            })
            if(selDevice.type!==214){
                if(selDevice.type===209&&selDevice.door_alarm===1){
                    nodeCol.push( 
                        {
                            title: '门状态',
                            dataIndex: 'door' ,
                            width: 100,
                            align: 'center',
                            render: (text, record) => (
                                <div>
                                    <div>{record['door']  === 0 ? "关门" : '开门'}</div>
                                </div>
                            )
                        }
                    )
                }
                nodeCol.push( 
                        {
                            title: '信号',
                            dataIndex: 'csq',
                            align: 'center',
                            width: 80,
                        })
                if(selDevice.type!==208){
                    nodeCol.push( 
                        {
                            title: '电源',
                            dataIndex: 'power',
                            align: 'center',
                            width: 80,
                            render: (text, record) => (
                                <div>{text === 0 ? "正常" : text === 1?"电池":''}</div>
                            )
                        },
                        {
                            title: '电量',
                            dataIndex: 'battery',
                            key: 'id',
                            align: 'center',
                            width: 80,
                        })
                }
                
            }
        }else{
            sd.map(({ node, name, district_name, m_name,id,door_alarm ,type,humi}) => {
                if (node!==0){
                    const  devNode= devNodeMap[node] || [];
                    let titleName = '温度'
                    if(type===218&&node%2===0){
                        titleName = 'co2'
                    }
                    let obj ={
                        title: `${name}-(区域:${district_name}-主机:${m_name}-测点ID:${node})`,
                        align: 'center',
                        children: [
                            {
                                title: `${titleName} (最大:${devNode.length>0?devNode[0].temp_h.toFixed(1):''} 
                                    最小:${devNode.length>0?devNode[0].temp_l.toFixed(1):''} 
                                    平均:${devNode.length>0?devNode[0].temp_s.toFixed(1):''})`,
                                align: 'center',
                                children:[
                                    
                                    
                                ]
                            }
                        ]
                    }
                    titleName = '温度(℃)'
                    let titleName_Limit = '上下限(℃)'
                    let tempobj = {
                        title: titleName,
                        dataIndex: 'temp' + node,
                        align: 'center',
                        width:100,
                        render: (text, record) =>  {
                            // 1. 卫语句：处理开关关闭的情况
                            if (record['temp_switch' + node] === 0) {
                                return <div>--</div>;
                            }
                        
                            // 2. 核心逻辑优化
                            // 原始代码中：text ? ... : ''
                            // 隐患：如果 text 为 0，会被判定为 false，导致显示为空字符串，而不是 "0.0"
                            if (text === undefined || text === null) {
                                return <div></div>;
                            }
                        
                            // 3. 特殊值判断与渲染
                            // 使用 toFixed 前必须确保 text 是数字类型
                            const isSpecialValue = [102.2, 102.3, -102.2, -102.3].includes(text);
                            let displayText = isSpecialValue ? " NL" : Number(text).toFixed(1);
    
                            // 4. 颜色控制
                            const color = record['temp_alarm' + node] === 1 ? 'red' : undefined;
                        
                            return (
                                <div style={{ color }}>
                                    {displayText}
                                </div>
                            );
                        }
                            
                    }
                    let dataIndexN = 'temp'
                    if(type===218&&node%2===0){
                        titleName='CO2(ppm)'
                        titleName_Limit = '上下限(ppm)'
                        dataIndexN= 'co2'
                        tempobj = {
                            title: titleName,
                            dataIndex: 'co2' + node,
                            align: 'center',
                            width:100,
                            render: (text, record) =>  {
                                // 1. 卫语句：处理开关关闭的情况
                                if (record['co2_switch' + node] === 0) {
                                    return <div>--</div>;
                                }  
                                // 2. 核心逻辑优化
                                // 原始代码中：text ? ... : ''
                                // 隐患：如果 text 为 0，会被判定为 false，导致显示为空字符串，而不是 "0.0"
                                if (text === undefined || text === null) {
                                    return <div></div>;
                                }
                            
                                // 3. 特殊值判断与渲染
                                // 使用 toFixed 前必须确保 text 是数字类型
                                const isSpecialValue = [102.2, 102.3, -102.2, -102.3].includes(text);
                                let displayText = isSpecialValue ? " NL" : parseInt(text);
                                // 4. 颜色控制
                                const color = record['co2_alarm' + node] === 1 ? 'red' : undefined;
                            
                                return (
                                    <div style={{ color }}>
                                        {displayText}
                                    </div>
                                );
                            }
                                
                        }
                    }
                    if(showHisLimit){
                        if(type===218&&node%2==0){
                            obj.children[0].children.push(
                                {
                                    title: titleName_Limit,
                                    dataIndex: 'co2_h' + node,
                                    align: 'center',
                                    width:100,
                                    render: (text, record) => {
                                           // 1. 提前判断开关状态，如果是 0 直接返回 null，减少后续计算
                                            if (record['co2_switch' + node] === 0) return null;
        
                                            // 2. 健壮性判断：使用 text == null 代替 text === undefined
                                            // 在 JS 中，== null 可以同时兼容 null 和 undefined 两种情况，更加安全
                                            if (text == null) return '';
        
                                            // 3. 正常渲染，并增加 toFixed(1) 保证小数位统一（结合你之前的代码习惯）
                                            return <div>{`${parseInt(text)}~${parseInt(record['co2_l' + node])}`}</div>;
                                    }
                                }
                            )
                        }else{
                            obj.children[0].children.push(
                                {
                                    title: titleName_Limit,
                                    dataIndex: 'temp_h' + node,
                                    align: 'center',
                                    width:100,
                                    render: (text, record) => {
                                           // 1. 提前判断开关状态，如果是 0 直接返回 null，减少后续计算
                                            if (record['temp_switch' + node] === 0) return null;
        
                                            // 2. 健壮性判断：使用 text == null 代替 text === undefined
                                            // 在 JS 中，== null 可以同时兼容 null 和 undefined 两种情况，更加安全
                                            if (text == null) return '';
        
                                            // 3. 正常渲染，并增加 toFixed(1) 保证小数位统一（结合你之前的代码习惯）
                                            return <div>{`${text.toFixed(1)}~${record['temp_l' + node].toFixed(1)}`}</div>;
                                    }
                                }
                            )
                        }
                    }
                    obj.children[0].children.push(
                        tempobj
                    )
                    if(type!==218||(type===218&&node%2!==0))obj.children[0].children.push(
                        {
                            title: '状态',
                            dataIndex: dataIndexN+'_alarm' + node,
                            align: 'center',
                            width: 60,
                            render: (text, record) => {
                                if(record[dataIndexN+'_switch' + node] === 0){
                                    return <div>--</div>
                                }
                                if (text === undefined || text === null) {
                                    return <div></div>;
                                }
                                const displayText = text === 1 ? "报警" :'正常';
                                const color = text === 1? 'red' : 'black';
                                return (
                                    <div style={{ color }}>
                                        {displayText}
                                    </div>
                                );
                            }
                        }
                    )
                    if (humi!==0){
                        obj.children.push({
                            title: `湿度 (最大:${devNode.length>0?devNode[0].humi_h:''} 
                                最小:${devNode.length>0?devNode[0].humi_l:''} 
                                平均:${devNode.length>0?devNode[0].humi_s.toFixed(1):''})`,
                            align: 'center',
                            children:[]
                        })
                        if(showHisLimit){
                            obj.children[1].children.push(
                                {
                                    title: '上下限(%RH)',
                                    dataIndex: 'humi_h' + node,
                                    align: 'center',
                                    width: 100,
                                    render: (text,record)=>( 
                                    <HumidityCell 
                                        text={text} 
                                        record={record} 
                                        node={node}    // 把 node 作为 props 传进去
                                        name={'上下限'}    // 把模式传进去
                                    />)
                                }
                            )
                        }
                        obj.children[1].children.push(
                            {
                                title: '湿度(%RH)',
                                dataIndex: 'humi' + node,
                                align: 'center',
                                width: 100,
                                render:(text,record)=>( 
                                    <HumidityCell 
                                        text={text} 
                                        record={record} 
                                        node={node}    // 把 node 作为 props 传进去
                                        name={'湿度'}    // 把模式传进去
                                    />)
                            },
                            {
                                title: '状态',
                                dataIndex: 'humi_alarm' + node,
                                width: 60,
                                align: 'center',
                                render: (text,record)=>( 
                                    <HumidityCell 
                                        text={text} 
                                        record={record} 
                                        node={node}    // 把 node 作为 props 传进去
                                        name={'状态'}    // 把模式传进去
                                    />)
                            }
                        )
                    }
                    if(type===214 &&door_alarm===1){
                        obj.children.push( {
                            title: '门状态',
                            align: 'center',
                            dataIndex:'door'+node,
                            width:80,
                            render:(text,record)=>{
                                return <div style={{color:text===1?'red':'black'}}>{text===1?'门开启':text===0?'门关闭':''}</div>
                            }
                        })
                    }
                    if(type===214||type===208){
                        obj.children.push( 
                        {
                            title: '电量',
                            align: 'center',
                            width:60,
                            dataIndex:'battery'+node
                        }
                    )}
                    nodeCol.push(obj)   
                }else{
                    door_alarm===1 &&
                    nodeCol.push({
                        title: '门状态',
                        dataIndex: 'door' + node,
                        width: 100,
                        align: 'center',
                        render: (text, record) => (
                            <div>
                                <div>{record['door' + node]  === 0 ? "关门" : '开门'}</div>
                            </div>
                        )
                    })
                }
            })
            if(selDevice.type!==214){
                if(selDevice.type===209&&selDevice.door_alarm===1){
                    nodeCol.push( 
                        {
                            title: '门状态',
                            dataIndex: 'door' ,
                            width: 100,
                            align: 'center',
                            render: (text, record) => (
                                <div>
                                    <div>{record['door']  === 0 ? "关门" : '开门'}</div>
                                </div>
                            )
                        }
                    )
                }
                nodeCol.push( 
                        {
                            title: '信号',
                            dataIndex: 'csq',
                            align: 'center',
                            width: 80,
                        })
                if(selDevice.type!==208){
                    nodeCol.push( 
                        {
                            title: '电源',
                            dataIndex: 'power',
                            align: 'center',
                            width: 80,
                            render: (text, record) => (
                                <div>{text === 0 ? "正常" : text === 1?"电池":''}</div>
                            )
                        },
                        {
                            title: '电量',
                            dataIndex: 'battery',
                            key: 'id',
                            align: 'center',
                            width: 80,
                        })
                }
                
            }
        }
        
        sd=null 
        return nodeCol
    },[selDevs,selDevice,selDevSt,showHisLimit,showSimple])
    const exportPDF =(type=0)=>{
        setLoading(true)
        let now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
        let url = "/v1/"
        let time ='';
        AMTimes.map(item=>item<10?time+=('0'+item+':00:00,'):time+=(item+':00:00,'));
        PMTimes.map(item=>time+=(item+':00:00,'));
        time=time.slice(0,-1);
        //普通报表下载
        if(tableType===0)
        {
            if(type!==0){
                url += "historydpdf?device=" + selDevice.sn + "&node=" + selNode + "&starttime=" ;
                startTime===''?url+= formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime()):
                endTime===''? url+=startTime+"&endtime=" + formatDateTimes(new Date().getTime()):
                url+=startTime+"&endtime=" + endTime;
                url+="&min="+interval;
                url+='&power=false&door=false&alarm=true'
                if(showHisLimit)url+='&range=true'
            }else{
                if(selDevice.type===214){
                    url += "historydwpdf?device=" + selDevice.sn + "&node=" + selNode + "&starttime=" ;
                    startTime===''?url+= formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime()):
                    endTime===''? url+=startTime+"&endtime=" + formatDateTimes(new Date().getTime()):
                    url+=startTime+"&endtime=" + endTime;
                    url+="&min="+interval;
                }else{
                    showHisModeNew?
                    url += "historydapdf?device=" + selDevice.sn + "&node=" +  selNode + "&starttime=":
                    url += "historydpdf?device=" + selDevice.sn + "&node=" + selNode + "&starttime=" ;
                    startTime===''?url+= formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime()):
                    endTime===''? url+=startTime+"&endtime=" + formatDateTimes(new Date().getTime()):
                    url+=startTime+"&endtime=" + endTime;
                    url+="&min="+interval;
                    if(showHisLimit)url+='&range=true'
                }
            }
            if (isMoreThan31Days(startTime,endTime)){
                // setLoading(false)
                // return message.warning('时间范围超过一个月');
                message.warning('时间范围超过一个月');
            }
        }
        //月报表下载
        if(tableType===3){
            url+="historymondpdf?device=" +selDevice.sn + "&node=" + selNode+ "&time=" + time+ '&mon='+monthTime;
            if (type!==0) url+='&power=false&door=false'
        }
        //周报表下载
        if(tableType===2||tableType===1){
            url+="historyweekdpdf?device="+selDevice.sn + "&node=" + selNode+ "&time=" + time +'&starttime='+startWeek+'&endtime=';
            url+=endWeek===''?formatDateTimes(new Date().getTime()):endWeek;
            if (type!==0) url+='&power=false&door=false'
        }
        
        if(!isExportHumi){
            url+="&humi=false"
        };
        if(isPDFCol){
            url+="&col=1"
        }
        if(Mode==='soc'){
            fetch(url, { //downloadFiles 接口请求地址
                method: 'get',
                credentials: 'include',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                })
            })
            .then((response) => {
                setLoading(false)
                response.blob().then(blob => {
                    let blobUrl = window.URL.createObjectURL(blob);
                    let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                    let filename = selDevice.m_name + '.pdf';//设置文件名称
                    if(selNode.length===1){
                        filename = selDevice.name + '.pdf'
                    }
                    aElement.href = blobUrl;//设置a标签路径
                    aElement.download = filename;
                    aElement.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
            }).catch((error) => {
                setLoading(false)
                console.log('文件下载失败', error);
            });
        }else{

            if(window.CefSharp!==undefined){
                window.CefSharp.BindObjectAsync("bound");
                let filename = selDevice.m_name + '.pdf';//设置文件名称
                if(selNode.length===1){
                    filename = selDevice.name + '.pdf'
                }
                let path = window.bound.exportPDF(filename);
                url+="&path=" + path;
                setLoading(false)
                http.get(url, {}).then(data=>{
                    if(data.code===0&&data.msg==="ok")message.success('PDF导出成功'+data.data,3);
                })
            }
        }
                                        
    }
    const exportExcel =(type=0)=>{
        setLoading(true)
        var now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
        let url = "/v1/"
        let time ='';
        AMTimes.map(item=>item<10?time+=('0'+item+':00:00,'):time+=(item+':00:00,'));
        PMTimes.map(item=>time+=(item+':00:00,'));
        time=time.slice(0,-1);
        //普通报表下载
        if(tableType===0)
        {
            if(type!==0){
                url += "historydliteexcel?device=" +selDevice.sn + "&node=" + selNode;
            }else{
                url+="historydexcel?device=" +selDevice.sn + "&node=" + selNode;
            }
            startTime===''?url+= "&starttime=" + formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime()):
            endTime===''? url+="&starttime=" + startTime+"&endtime=" + formatDateTimes(new Date().getTime()):
            url+="&starttime=" + startTime+"&endtime=" + endTime;
            url+="&min="+interval;
            if (isMoreThan31Days(startTime,endTime)){
                setLoading(false)
                return message.warning('时间范围超过一个月');
            }
        }
        //月报表下载
        if(tableType===3){
            url+="historymondexcel?device=" +selDevice.sn + "&node=" + selNode+ "&time=" + time+ '&mon='+monthTime;
        }
        //周,日报表下载
        if(tableType===2||tableType===1){
            url+="historyweekdexcel?device="+selDevice.sn + "&node=" + selNode+ "&time=" + time +'&starttime='+startWeek+'&endtime=';
            url+=endWeek===''?formatDateTimes(new Date().getTime()):endWeek;
        }
        if(!isExportHumi){
            url+="&humi=false"
        };
        if(Mode==='soc'){
            fetch(url, { //downloadFiles 接口请求地址
                method: 'get',
                credentials: 'include',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                })
            })
            .then((response) => {
                setLoading(false)
                response.blob().then(blob => {
                    let blobUrl = window.URL.createObjectURL(blob);
                    let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                    let filename = selDevice.name + '.xlsx';//设置文件名称
                    aElement.href = blobUrl;//设置a标签路径
                    aElement.download = filename;
                    aElement.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
            }).catch((error) => {
                setLoading(false)
                console.log('文件下载失败', error);
            });
        }else{
            if(window.CefSharp!==undefined){
                window.CefSharp.BindObjectAsync("bound");
                let path = window.bound.exportEXCEL(selDevice.m_name + '.pdf');
                url+="&path=" + path;
                setLoading(false)
                http.get(url, {}).then(data=>{
                    if(data.code===0&&data.msg==="ok")message.success('EXCEL导出成功'+data.data,3);
                })
            }
        }
    }
    const getScrollY = () => {
        const h = state.resolution.height;
        const w = state.resolution.width;
        let calc = 0
        if (showSimple){
            calc=90
        } 
        // 基础高度计算
        let baseHeight = h > 700 ? (w > 980 ? h - 500-calc : h - 550-calc) : 180-calc;
        
        // 如果显示总结栏，确保有足够空间，或者稍微减小一点表格主体高度以防溢出
        // 实际上只要父容器没锁死高度，Table 会自动处理，但为了保险可以微调
        return baseHeight; 
    };
    /**
     * 打印折线图
     */
    function getChartImage() {
        var imgUrl = myChartP&&myChartP.getDataURL({
            // 指定图片的宽度和高度
            pixelRatio: 0.8,
            backgroundColor: '#fff'
        });
        return imgUrl;
    }
    /**
     * 批量请求数据
     * @param {Array<>} tasks - http请求数组
     * @param {number} batchSize - 同时请求的数量默认为同时向服务器发起5次请求
     * @returns {Array<Array<>>} - 二维数组 将每批次请求的数据数组 放到数组中
     */
    function getBatchTasks(tasks, batchSize = 5) {
        const results = [];
        
        // 使用 async/await 循环来处理“串行中的并发”
        return (async () => {
          for (let i = 0; i < tasks.length; i += batchSize) {
            // 1. 截取当前批次的任务
            const batch = tasks.slice(i, i + batchSize);
            
            // 2. 等待当前批次全部完成
            const batchResults = await Promise.all(batch);
            const batchResult = []
            batchResults.map(res => {
                // 根据你的实际返回结构调整，这里假设 res.data 就是列表数组
                if(res.code===0&&res.data&&res.data.length>0){
                    batchResult.push(...res.data)
                }
              });
            // 3. 将结果合并到大数组中
            if(batchResult.length>0){
                results.push(batchResult);
            }
            // 可选：打印进度
            setDataPro(Math.floor((i + batchSize)*100/tasks.length))
          }
          return results;
        })();
    }
    /**
     * 将时间段按天拆分为起始和结束时间段数组
     * @param {string} startStr - 起始时间 "yyyy-mm-dd hh:mm:ss"
     * @param {string} endStr - 结束时间 "yyyy-mm-dd hh:mm:ss"
     * @returns {Array<{start: string, end: string}>} - 包含 start 和 end 对象的数组
     */
    function splitRangeByDay(startStr, endStr) {
        const result = [];
        
        // 1. 初始化日期对象
        let currentStart = new Date(startStr.replace(/-/g, '/'));
        let currentEnd = new Date(endStr.replace(/-/g, '/'));
        
        // 2. 获取日期的字符串部分 (yyyy-mm-dd) 用于比较是否同一天
        const getDateString = (d) => {
            const pad = (n) => n.toString().padStart(2, '0');
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
        };

        const startDateStr = getDateString(currentStart);
        const endDateStr = getDateString(currentEnd);

        // 3. 情况一：起始和结束在同一天
        if (startDateStr === endDateStr) {
            result.push({
                start: formatDateTime(currentStart),
                end: formatDateTime(currentEnd)
            });
            return result;
        }

        // 4. 情况二：跨天处理
        
        // --- 第一步：处理第一天 (起始时间 -> 当天 23:59:59) ---
        let dayEnd = new Date(currentStart);
        dayEnd.setHours(23, 59, 59, 999); // 设置为当天的最后一毫秒
        
        result.push({
            start: formatDateTime(currentStart), // 保持原始起始时间
            end: formatDateTime(dayEnd)
        });

        // --- 第二步：处理中间完整的天数 (00:00:00 -> 23:59:59) ---
        // 从起始日期的下一天开始循环
        let loopDate = new Date(currentStart);
        loopDate.setDate(loopDate.getDate() + 1);

        while (getDateString(loopDate) !== endDateStr) {
            let midStart = new Date(loopDate);
            midStart.setHours(0, 0, 0, 0);
            
            let midEnd = new Date(loopDate);
            midEnd.setHours(23, 59, 59, 999);

            result.push({
                start: formatDateTime(midStart),
                end: formatDateTime(midEnd)
            });

            // 进入下一天
            loopDate.setDate(loopDate.getDate() + 1);
        }

        // --- 第三步：处理最后一天 (当天 00:00:00 -> 原始结束时间) ---
        let lastStart = new Date(currentEnd);
        lastStart.setHours(0, 0, 0, 0);

        result.push({
            start: formatDateTime(lastStart),
            end: formatDateTime(currentEnd) // 保持原始结束时间
        });

        return result;
    }

    /**
     * 格式化日期为 yyyy-mm-dd hh:mm:ss
     */
    function formatDateTime(date) {
        const pad = (num) => num.toString().padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    }
    /**
     * 数据分组：按探头测点分组
     * @param {obj[]} data - 原始数组
     */
    function groupByNodeOptimized(data) {
        const groupMap = new Map();
        // 单次遍历：O(N)
        for (const item of data) {
            const node = item.node;
            
            // 如果 Map 中还没有这个 name 的组，初始化一个空数组
            if (!groupMap.has(node)) {
                groupMap.set(node, []);
            }
            
            // 将当前项的引用 push 进对应的数组
            // 注意：这里没有创建新对象，只是复制了引用，内存开销极小
            groupMap.get(node).push(item);
        }

        return groupMap;
    }
    /**
     * 数据降采样：按倍数缩小，每组取最大值和最小值
     * @param {obj[]} data - 原始数组
     * @param {number} scale - 缩小倍数 (例如 2 或 3)
     * @returns {obj[]} - 处理后的新数组
     */
    function downsampleData(data, scale,isHumi) {
        // 1. 计算步长：缩小2倍->每8个
        const result = [];
        if (isHumi){
            const step = scale * 4; 
            for (let i = 1; i < data.length-1; i += step) {
                // 2. 截取当前的一组数据 (例如从 i 到 i+4)
                const chunk = data.slice(i, i + step);
                // 如果截取不到数据，直接跳出
                if (chunk.length === 0) break;
                // 3. 计算当前组的最大值和最小值
                let maxObj = {data_time:chunk[1].data_time,name:chunk[1].name,temp:chunk[1].temp,humi:chunk[1].humi,node:chunk[1].node};
                let minObj = {data_time:chunk[1].data_time,name:chunk[1].name,temp:chunk[1].temp,humi:chunk[1].humi,node:chunk[1].node};
                let maxObjh = {data_time:chunk[1].data_time,name:chunk[1].name,temp:chunk[1].temp,humi:chunk[1].humi,node:chunk[1].node};
                let minObjh = {data_time:chunk[1].data_time,name:chunk[1].name,temp:chunk[1].temp,humi:chunk[1].humi,node:chunk[1].node};
                for (let j = 1; j < chunk.length; j++) {
                    const currentVal = chunk[j].temp;
                    const currentValh = chunk[j].humi;
                    if (currentVal > maxObj.temp) maxObj ={data_time:chunk[j].data_time,name:chunk[j].name,temp:chunk[j].temp,humi:chunk[j].humi,node:chunk[j].node} ;
                    if (currentVal < minObj.temp) minObj = {data_time:chunk[j].data_time,name:chunk[j].name,temp:chunk[j].temp,humi:chunk[j].humi,node:chunk[j].node};
                    if (currentValh > maxObjh.humi) maxObjh ={data_time:chunk[j].data_time,name:chunk[j].name,temp:chunk[j].temp,humi:chunk[j].humi,node:chunk[j].node} ;
                    if (currentValh < minObjh.humi) minObjh = {data_time:chunk[j].data_time,name:chunk[j].name,temp:chunk[j].temp,humi:chunk[j].humi,node:chunk[j].node};
                }
                const sorted = [{data_time:data[0].data_time,name:data[0].name,temp:data[0].temp,humi:data[0].humi,node:data[0].node}];
                // 4. 推入结果数组 
                if(maxObj.data_time===minObj.data_time){
                    sorted.push(maxObj);
                }else{
                    if(maxObj.data_time>minObj.data_time){
                        sorted.push(minObj);
                        sorted.push(maxObj);
                    }else{
                        sorted.push(maxObj);
                        sorted.push(minObj);
                    }
                }
                sorted.push(maxObjh)
                sorted.push(minObjh)
                sorted.push({data_time:data[data.length-1].data_time,name:data[data.length-1].name,temp:data[data.length-1].temp,humi:data[data.length-1].humi,node:data[data.length-1].node})
                sorted.sort((a,b)=>{
                    const timeA = new Date(a.data_time).getTime() || 0;
                    const timeB = new Date(b.data_time).getTime() || 0;
                    return timeA - timeB;
                }) 
                const uniqueMap = new Map();
                for (const obj of sorted) {
                    if (!uniqueMap.has(obj.data_time)) {
                        uniqueMap.set(obj.data_time, true);
                        result.push(obj);
                    }
                }
                uniqueMap.clear();
            }
        }else{
            const step = scale * 2; 
            for (let i = 1; i < data.length-1; i += step) {
                // 2. 截取当前的一组数据 (例如从 i 到 i+4)
                const chunk = data.slice(i, i + step);
        
                // 如果截取不到数据，直接跳出
                if (chunk.length === 0) break;
                // 3. 计算当前组的最大值和最小值
                let maxObj = {data_time:chunk[1].data_time,name:chunk[1].name,temp:chunk[1].temp,humi:chunk[1].humi,node:chunk[1].node};
                let minObj = {data_time:chunk[1].data_time,name:chunk[1].name,temp:chunk[1].temp,humi:chunk[1].humi,node:chunk[1].node};
                for (let j = 1; j < chunk.length; j++) {
                    const currentVal = chunk[j].temp;
                    if (currentVal > maxObj.temp) maxObj ={data_time:chunk[j].data_time,name:chunk[j].name,temp:chunk[j].temp,humi:chunk[j].humi,node:chunk[j].node} ;
                    if (currentVal < minObj.temp) minObj = {data_time:chunk[j].data_time,name:chunk[j].name,temp:chunk[j].temp,humi:chunk[j].humi,node:chunk[j].node};
                }
                result.push({data_time:data[0].data_time,name:data[0].name,temp:data[0].temp,humi:data[0].humi,node:data[0].node});
                // 4. 推入结果数组 
                if(maxObj.data_time===minObj.data_time){
                    result.push(maxObj);
                }else{
                    if(maxObj.data_time>minObj.data_time){
                        result.push(minObj);
                        result.push(maxObj);
                    }else{
                        result.push(maxObj);
                        result.push(minObj);
                    }
                }
                result.push({data_time:data[data.length-1].data_time,name:data[data.length-1].name,temp:data[data.length-1].temp,humi:data[data.length-1].humi,node:data[data.length-1].node});
            }
        }
        

        return result;
    }
    
    /**
     * 历史数据处理：将后台请求的数据进行展示，按照table表格和折线图的样式处理数据
     * @param {obj[]} dataF - 原始数组
     * @param {string} startTime - 开始时间
     * @param {string} endTime - 结束时间
     */
    function hisDataDeal(dataF,startTime,endTime,selDev_=false,selNodes_=false,selDevs_=false){
        if (dataF.length===0) return message.warning('暂无数据');
        let isHumi = false;
        let selDevTs = selDevs
        let selDevT = selDevice
        let selNodeTs = selNode
        if(selDevs_){
            selDevTs = selDevs_
        }
        if(selDev_){
            selDevT = selDev_
        }
        if(selNodes_){
            selNodeTs = selNodes_
        }
        let sss= selDevTs.find(x=>x.humi===1);//查找是否有湿度数据

        if(sss){
            setIsHumi(true);
            isHumi= true;
        }
        const has_co2 =selDevTs.some(x=>x.type===218&&x.node>0&&x.node%2==0);
        let baseData=[]
        let dataDeal=[]
        let maxNum=0
        let maxTableNum=0
        let dev_val=[]; //每个测点的温度湿度最大最小值总计和数量
        // const nodeMap = new Map(dev_val.map(x => [x.node, x]));
        const nodeStatsMap = {};
        const trips_ = [];
        let trip_index = 0
        let tripStartTime = null; 
        dataF.forEach(d=>{
            if(showHisModeNew&&[201,208,212].includes(selDevT.type)){
                d=d.filter(x=>(+x.data_time.slice(-5,-3)%30===0)||x.temp>x.temp_h||x.temp<x.temp_l||x.humi>x.humi_h||x.humi<x.humi_l)
            }
            const tableData=[]
            const timeMap = new Map(baseData.map(x => [x.data_time, x]));
            const ar=[]
            if(has_co2){
                d.forEach(m => {
                    // 通过哈希表快速定位 (替代find)
                    const existing = timeMap.get(m.data_time);
                    //将符合条件的数据
                    const fields = {
                        temp: m.temp,
                        temp_h: m.temp_h,
                        temp_l: m.temp_l,
                        temp_alarm: m.temp_alarm,
                        temp_switch: m.temp_switch,
                        humi: m.humi,
                        humi_h: m.humi_h,
                        humi_l: m.humi_l,
                        humi_alarm: m.humi_alarm,
                        humi_switch: m.humi_switch,
                        humi_enable: m.humi_enable,
                        districtname: m.districtname,
                        door: m.door
                    };
                    const fields_1 = {
                        co2: m.temp*100,
                        co2_h: m.temp_h,
                        co2_l: m.temp_l,
                        co2_alarm: m.temp_alarm,
                        co2_switch: m.temp_switch,
                        humi: m.humi,
                        humi_h: m.humi_h,
                        humi_l: m.humi_l,
                        humi_alarm: m.humi_alarm,
                        humi_switch: m.humi_switch,
                        humi_enable: m.humi_enable,
                        districtname: m.districtname,
                        door: m.door,
                    };
                    if (existing) {
                        // 批量赋值代替逐属性修改
                        const nodeSuffix = m.node;
                        if(m.node>0&&m.node%2===0){
                            Object.entries(fields_1).forEach(([key, val]) => {
                                existing[`${key}${nodeSuffix}`] = val;
                            });
                        }else{
                            Object.entries(fields).forEach(([key, val]) => {
                                existing[`${key}${nodeSuffix}`] = val;
                            });
                        }
                        
                    } else {
                        // 创建新对象时一次性构建所有属性
                        const newNode = { data_time: m.data_time };
                        const nodeSuffix = m.node;

                        if(m.node>0&&m.node%2===0){
                            Object.entries(fields_1).forEach(([key, val]) => {
                                newNode[`${key}${nodeSuffix}`] = val;
                            });
                        }else{
                            Object.entries(fields).forEach(([key, val]) => {
                                newNode[`${key}${nodeSuffix}`] = val;
                            });
                        }
                        newNode.csq = m.csq; 
                        newNode.power=m.power
                        newNode.battery=m.battery
                        timeMap.set(m.data_time, newNode);
                        tableData.push(newNode);
                    }
                    const is_vail_temp = m.temp_switch>0&&![102.2,102.3,-102.2,-102.3].includes(m.temp)
                    const is_vail_humi = m.humi_enable>0&&m.humi_switch>0&&![102.2,102.3,-102.2,-102.3].includes(m.humi)
                    let temp = is_vail_temp?m.temp:null
                    let humi = is_vail_humi?m.humi:null
                    const nodeId = m.node;
                    if(m.node>0&&m.node%2===0){
                        if(temp){
                            temp = temp*100
                        }
                        ar.push({
                            ...m,
                            co2:temp,
                            // humi:humi,
                        })
                        if (!nodeStatsMap[nodeId]) {
                            nodeStatsMap[nodeId] = {
                                co2: { sum: 0, count: 0, max: -Infinity, min: Infinity }
                            };
                        }
                        const stats = nodeStatsMap[nodeId];
                        
                        // 独立统计温度（仅当开关开启且值有效时）
                        if (is_vail_temp) {
                            stats.co2.sum += temp;
                            stats.co2.count++;
                            if (temp > stats.co2.max) stats.co2.max = temp;
                            if (temp < stats.co2.min) stats.co2.min = temp;
                        }
                    }else{
                        ar.push({
                            ...m,
                            temp:temp,
                            humi:humi,
                        })
                        if (!nodeStatsMap[nodeId]) {
                            nodeStatsMap[nodeId] = {
                                temp: { sum: 0, count: 0, max: -Infinity, min: Infinity },
                                humi: { sum: 0, count: 0, max: -Infinity, min: Infinity }
                            };
                        }
                        const stats = nodeStatsMap[nodeId];
                        
                        // 独立统计温度（仅当开关开启且值有效时）
                        if (is_vail_temp) {
                            stats.temp.sum += m.temp;
                            stats.temp.count++;
                            if (m.temp > stats.temp.max) stats.temp.max = m.temp;
                            if (m.temp < stats.temp.min) stats.temp.min = m.temp;
                        }
                
                        // 独立统计湿度（仅当开关开启且值有效时）
                        if (is_vail_humi) {
                            stats.humi.sum += m.humi;
                            stats.humi.count++;
                            if (m.humi > stats.humi.max) stats.humi.max = m.humi;
                            if (m.humi < stats.humi.min) stats.humi.min = m.humi;
                        }
                    }
                    
                    
                })
            }else{

                d.forEach(m => {
                    // 通过哈希表快速定位 (替代find)
                    const existing = timeMap.get(m.data_time);
                    if (existing) {
                        // 批量赋值代替逐属性修改
                        const nodeSuffix = m.node;
                        const fields = {
                            temp: m.temp,
                            temp_h: m.temp_h,
                            temp_l: m.temp_l,
                            temp_alarm: m.temp_alarm,
                            temp_switch: m.temp_switch,
                            humi: m.humi,
                            humi_h: m.humi_h,
                            humi_l: m.humi_l,
                            humi_alarm: m.humi_alarm,
                            humi_switch: m.humi_switch,
                            humi_enable: m.humi_enable,
                            districtname: m.districtname,
                            door: m.door,
                            power: m.power,
                            battery: m.battery,
                            type: m.type,
                            gps_dir: m.gps_dir
                        };
    
                        Object.entries(fields).forEach(([key, val]) => {
                            existing[`${key}${nodeSuffix}`] = val;
                        });
                    } else {
                        // 创建新对象时一次性构建所有属性
                        const newNode = { data_time: m.data_time };
                        const nodeSuffix = m.node;
    
                        [
                            ['temp', m.temp],
                            ['temp_h', m.temp_h],
                            ['temp_l', m.temp_l],
                            ['temp_alarm', m.temp_alarm],
                            ['temp_switch', m.temp_switch],
                            ['humi', m.humi],
                            ['humi_h', m.humi_h],
                            ['humi_l', m.humi_l],
                            ['humi_alarm', m.humi_alarm],
                            ['humi_switch', m.humi_switch],
                            ['humi_enable', m.humi_enable],
                            ['districtname', m.districtname],
                            ['door', m.door],
                            ['power', m.power],
                            ['battery', m.battery],
                            ['type', m.type],
                            ['gps_dir', m.gps_dir]
                        ].forEach(([key, val]) => {
                            newNode[`${key}${nodeSuffix}`] = val;
                            newNode[`${key}`]=val;
                        });
                        newNode.csq = m.csq; 
                        timeMap.set(m.data_time, newNode);
                        tableData.push(newNode);
                    }
                    const is_vail_temp = m.temp_switch>0&&![102.2,102.3,-102.2,-102.3].includes(m.temp)
                    const is_vail_humi = m.humi_enable>0&&m.humi_switch>0&&![102.2,102.3,-102.2,-102.3].includes(m.humi)
                    let temp = is_vail_temp?m.temp:null
                    let humi = is_vail_humi?m.humi:null
                    ar.push({
                        ...m,
                        temp:temp,
                        humi:humi,
                    })
                    const nodeId = m.node;
                    if (!nodeStatsMap[nodeId]) {
                        nodeStatsMap[nodeId] = {
                            temp: { sum: 0, count: 0, max: -Infinity, min: Infinity },
                            humi: { sum: 0, count: 0, max: -Infinity, min: Infinity }
                        };
                    }
                    const stats = nodeStatsMap[nodeId];
                    
                    // 独立统计温度（仅当开关开启且值有效时）
                    if (is_vail_temp) {
                        stats.temp.sum += m.temp;
                        stats.temp.count++;
                        if (m.temp > stats.temp.max) stats.temp.max = m.temp;
                        if (m.temp < stats.temp.min) stats.temp.min = m.temp;
                    }
            
                    // 独立统计湿度（仅当开关开启且值有效时）
                    if (is_vail_humi) {
                        stats.humi.sum += m.humi;
                        stats.humi.count++;
                        if (m.humi > stats.humi.max) stats.humi.max = m.humi;
                        if (m.humi < stats.humi.min) stats.humi.min = m.humi;
                    }

                    if(m.gps_dir===1){
                        if(tripStartTime){
                            const diffMs = new Date(m.data_time).getTime() - new Date(tripStartTime).getTime();
                            const durationMinutes = Math.floor(diffMs / (1000 * 60));
                            trip_index++
                            trips_.push({
                                id:trip_index,
                                start_time: tripStartTime,
                                end_time: m.data_time,
                                duration:durationMinutes,
                                status:1
                            });
                            tripStartTime =  m.data_time
                        }else{
                            tripStartTime = m.data_time;
                            console.log('start',tripStartTime);
                        }
                    } else if (m.gps_dir === 2) {
                        if (tripStartTime !== null) {
                            const diffMs = new Date(m.data_time).getTime() - new Date(tripStartTime).getTime();
                            const durationMinutes = Math.floor(diffMs / (1000 * 60));
                            trip_index++
                            trips_.push({
                                id:trip_index,
                                start_time: tripStartTime,
                                end_time: m.data_time,
                                duration:durationMinutes,
                                status:0
                            });
                            console.log('end','行程+1');
                           
                        }else{
                            const diffMs = new Date(m.data_time).getTime() - new Date(startTime).getTime();
                            const durationMinutes = Math.floor(diffMs / (1000 * 60));
                            trip_index++
                            trips_.push({
                                id:trip_index,
                                start_time: startTime,
                                end_time: m.data_time,
                                duration:durationMinutes,
                                status:2
                            });
                            console.log('end','没有 start');
                        } 
                        tripStartTime = null; // 配对完成，重置
                    }
                })
                if (tripStartTime){
                    trip_index++
                    trips_.push({
                        id:trip_index,
                        start_time: tripStartTime,
                        end_time: '',
                        duration:0,
                        status:3
                    }); 
                }
            }
            timeMap.clear()
            maxTableNum+=tableData.length
            baseData.push(tableData.reverse())
            dataDeal.push(ar)
            maxNum+=ar.length;  
        })
        dataF =null
        setData(baseData.reverse());
        setRecordCount(maxTableNum+'');
        //计算每个测点的统计数据，以及显示的table表结构
        let tmax =-Infinity;let tmin =Infinity; let hmax =-Infinity;let hmin =Infinity; let tavg =0; let havg =0; let humi =false
        const calcAvg = (s) => {
            return s.count > 0 ? parseFloat((s.sum / s.count).toFixed(2)) : 0;
        }
        if(has_co2){
            let cmax =-Infinity;let cmin =Infinity;let cavg =0;
            for (const [nodeId, stats] of Object.entries(nodeStatsMap)) {
                if(nodeId%2==0){
                    cmax = stats.co2.count > 0 ? stats.co2.max : 0;
                    cmin = stats.co2.count > 0 ? stats.co2.min : 0;
                    cavg = calcAvg(stats.co2);
                    dev_val.push({node:nodeId,temp_h:cmax,temp_l:cmin,temp_s:cavg,tempcount:stats.temp.count,humi:false})
                }else{
                    tmax = stats.temp.count > 0 ? stats.temp.max : 0;
                    tmin = stats.temp.count > 0 ? stats.temp.min : 0;
                    tavg = calcAvg(stats.temp);
                    humi = selDevTs.find(x=>x.node===(nodeId*1)&&x.humi===1)?true:false
                    if(humi){
                        hmax = stats.humi.count > 0 ? stats.humi.max : 0;
                        hmin = stats.humi.count > 0 ? stats.humi.min : 0;
                        havg = calcAvg(stats.humi);
                        dev_val.push({node:nodeId,temp_h:tmax,temp_l:tmin,humi_l:hmin,humi_h:hmax,temp_s:tavg,humi_s:havg,tempcount:stats.temp.count,humicount:stats.humi.count,humi:humi,tsum:stats.temp.sum,hsum:stats.humi.sum})
                    }else{
                        dev_val.push({node:nodeId,temp_h:tmax,temp_l:tmin,temp_s:tavg,tempcount:stats.temp.count,tsum:stats.temp.sum,humi:humi})
                    }
                }
               
            }
        }else{
            for (const [nodeId, stats] of Object.entries(nodeStatsMap)) {
                tmax = stats.temp.count > 0 ? stats.temp.max : 0;
                tmin = stats.temp.count > 0 ? stats.temp.min : 0;
                tavg = calcAvg(stats.temp) ;
                humi = selDevTs.find(x=>x.node===(nodeId*1)&&x.humi===1)?true:false
                if(humi){
                    hmax = stats.humi.count > 0 ? stats.humi.max : 0;
                    hmin = stats.humi.count > 0 ? stats.humi.min : 0;
                    havg = calcAvg(stats.humi) ;
                    dev_val.push({node:nodeId,temp_h:tmax,temp_l:tmin,humi_l:hmin,humi_h:hmax,temp_s:tavg,humi_s:havg,tempcount:stats.temp.count,humicount:stats.humi.count,tsum:stats.temp.sum,hsum:stats.humi.sum,humi:humi})
                }else{
                    dev_val.push({node:nodeId,temp_h:tmax,temp_l:tmin,temp_s:tavg,tempcount:stats.temp.count,tsum:stats.temp.sum,humi:humi})
                }
            }
        }
        setSelDevSt(dev_val)
        tmax =-Infinity; tmin =Infinity; hmax =-Infinity; hmin =Infinity;  tavg =0;  havg =0; 
        let tsum =0; let tcount = 0; let hsum=0; let hcount = 0;
        dev_val.map(item=>{
            if (item.temp_h > tmax) tmax = item.temp_h;
            if (item.temp_l < tmin) tmin = item.temp_l;
            if (item.humi_h > hmax) hmax = item.humi_h;
            if (item.humi_l < hmin) hmin = item.humi_l;
            tsum += item.tsum 
            hsum += item.hsum;
            tcount += item.tempcount
            hcount += item.humicount
        })
        tavg = calcAvg({sum:tsum,count:tcount})
        havg = calcAvg({sum:hsum,count:hcount})
        setDataF({ tmax, tmin, tavg, hmin, hmax, havg });
        setTrips(trips_)
        if(dataDeal.length===0||dataDeal[0].length===0) return
        // 
        // 折线图
        setTimeout(() => {
            let result = [];
            let co2Result=[]
            let seriesData=[]
            const startObj = {data_time:dataDeal[0][0].data_time,name:dataDeal[0][0].name,temp:dataDeal[0][0].temp,humi:dataDeal[0][0].humi,node:dataDeal[0][0].node,
                humi_switch:dataDeal[0][0].humi_switch,humi_enable:dataDeal[0][0].humi_enable};
            
            if (maxNum === 0) {
                message.warning('暂无有效数据');
            }else{
                if(startTime<startObj.data_time){
                    selDevTs.filter(x=>(x.type!==218||(x===218&&x.node%2!==0))).forEach(m=>{
                        result.push({data_time:startTime,name:m.name,temp:null,humi:null,node:m.node})
                    })
                }
                if(maxNum>16000){
                    let dataChartFil = Math.floor(maxNum/10000);
                    //处理下首批数据预防去掉每个探头的开头数据
                    const groupList= groupByNodeOptimized(dataDeal[0])
                    selDevTs.forEach(m=>{
                        const nodeData = groupList.get(m.node)
                        if (nodeData){
                            const firstL = downsampleData(nodeData,dataChartFil,m.humi===1);
                            if(firstL[0].data_time>startObj.data_time){
                                if(nodeData[0].humi_switch&&nodeData[0].humi_enable){
                                    result.push({data_time:nodeData[0].data_time,name:nodeData[0].name,temp:nodeData[0].temp,humi:nodeData[0].humi,node:nodeData[0].node})
                                }else{
                                    result.push({data_time:nodeData[0].data_time,name:nodeData[0].name,temp:nodeData[0].temp,node:nodeData[0].node})
                                }
                                
                            }
                            firstL.forEach(n=>{
                                if(m.humi===1){
                                    result.push({data_time:n.data_time,name:n.name,node:n.node,temp:n.temp,humi:n.humi})
                                }else{
                                    result.push({data_time:n.data_time,name:n.name,node:n.node,temp:n.temp})
                                }
                                
                            });
                        }
                    })
                    groupList.clear()

                    for (let index = 1; index < dataDeal.length; index++) {
                        const groupList= groupByNodeOptimized(dataDeal[index])
                        selDevTs.forEach(m=>{
                            const nodeData = groupList.get(m.node)
                            if(nodeData){
                                downsampleData(nodeData,dataChartFil,m.humi===1).forEach(n=>{
                                    if(m.humi===1){
                                        result.push({data_time:n.data_time,name:n.name,node:n.node,temp:n.temp,humi:n.humi})
                                    }else{
                                        result.push({data_time:n.data_time,name:n.name,node:n.node,temp:n.temp})
                                    }
                                });
                            }
                            
                        })
                        groupList.clear()
                    }
                    result.sort((a,b)=>{
                        const timeA = new Date(a.data_time).getTime() || 0;
                        const timeB = new Date(b.data_time).getTime() || 0;
                        if(timeA !== timeB){
                            return timeA - timeB;
                        }else{
                            return a.node - b.node;
                        }
                    }); 

                    setTooltip(false)
                    setTooltip1(false)
                }else{
                    setTooltip({showTitle: true,shared: true})
                    setTooltip1({trigger: 'axis'})
                    if(has_co2){
                        dataDeal.forEach(list=>{
                            // list.forEach(m=>{result.push(m)});
                            list.forEach(m=>{
                                if(m.node%2==0){
                                    co2Result.push({data_time:m.data_time,name:m.name,co2:m.co2,node:m.node})
                                }else{
                                    if(m.humi_enable&&m.humi_switch){
                                        result.push({data_time:m.data_time,name:m.name,temp:m.temp,humi:m.humi,node:m.node})
                                    }else{
                                        result.push({data_time:m.data_time,name:m.name,temp:m.temp,node:m.node})
                                    }
                                }
                            });
                        })
                    }else{
                        dataDeal.forEach(list=>{
                            // list.forEach(m=>{result.push(m)});
                            list.forEach(m=>{
                                if(m.humi_enable&&m.humi_switch){
                                    result.push({data_time:m.data_time,name:m.name,temp:m.temp,humi:m.humi,node:m.node})
                                }else{
                                    result.push({data_time:m.data_time,name:m.name,temp:m.temp,node:m.node})
                                }
                             
                            });
                        })
                    }
                    
                }
                if(endTime>baseData[0][0].data_time){
                    selDevTs.filter(x=>(x.type!==218||(x===218&&x.node%2!==0))).forEach(m=>{
                        result.push({data_time:endTime,name:m.name,temp:null,humi:null,node:m.node})
                    })
                }
                setdataChart(result);
                setCo2Datas(co2Result)
                
                const groupList_t= groupByNodeOptimized(result)
                //charts
                selDevTs.map(item=>{
                    const nodeList= groupList_t.get(item.node)
                    const tempdata =[];
                    const humidata =[];
                    if(item.type===218&&item.node%2===0){

                    }else{
                        nodeList.forEach(val=>{
                            tempdata.push([val.data_time,val.temp]);
                            humidata.push([val.data_time,val.humi]);
                        })
                        let name =item.name;
                        seriesData.push({
                            'name':name+'温度曲线',
                            type: 'line',
                            smooth: true,
                            symbol: 'none',
                            data: tempdata,
                        })
                        item.humi===1&&seriesData.push({
                            'name':name+'湿度曲线',
                            type: 'line',
                            smooth: true,
                            symbol: 'none',
                            data: humidata,
                        })
                    }
                   
                    
                })
                groupList_t.clear()

                
                if(selNodeTs.length===1){
                    if(selNodeTs[0].type===218&&selNodeTs[0].node%2===0){

                    }else{
                        setDataP(JSON.parse(JSON.stringify(baseData.flat())))
                    }
                    
                }
                setSeriesTempData(seriesData);         
            }
            if(tabKey==='2'){
                let title={
                    left: 'center',
                    text:isHumi?`${userName}\n${startTime}-${endTime}曲线图 \n 温度最小值${tmin}温度最大值${tmax}湿度最小值${hmin}湿度最大值${hmax}`:`${userName}\n${startTime}-${endTime}曲线图 \n 温度最小值${tmin}温度最大值${tmax}`
                }
                if (maxNum >16000){
                    showMyChart(seriesData,title,false)
                }else{
                    showMyChart(seriesData,title)
                }
                
            } 
            baseData = null;
            result = null;
            dataDeal =null;
            dev_val=null;
        }, 1000);                     
    }
    /**
     * 获取历史数据：向后台批量请求历史数据
     */
    async function getHisData(selDev_=false,selNodes_=false,selDevs_ = false) {
        setIsHumi(false);
        setDataPro(0)
        //初始化
        setDataF({tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 });
        setdataChart([]);
        setData([]);
        setSelNodeColums([])
        setSeriesTempData([])
        let selDevT = selDevice
        let selNodesT = selNode
        let selDevTs = selDevs
        if(selDev_){
            selDevT = selDev_
        }
        if(selNodes_){
            selNodesT = selNodes_
        }
        if(selDevs_){
            selDevTs =selDevs_
        }
        if (selDevT.sn === undefined || selDevT.node === undefined) return message.warning('未选择设备');
        let sss= selDevTs.find(x=>x.humi===1);//查找是否有湿度数据
        let isHumi = false
        if(sss){
            isHumi= true;
        }
        let isShowBoundWT = true
        let isShowBoundWH = true
        let isShowBound = true
        let selNodes= selNodesT.length>1?selNodesT.filter(x=>x!==0):selNodesT
        let devicestateTemp = state_device.devicestate.filter(x=>x.Sn===selDevT.sn&&selNodes.includes(x.Node))
        let fristdevice = devicestateTemp[0].Sensor;
        if(fristdevice.TempWarningLow===fristdevice.TempWarningHigh){
            isShowBoundWT = false
        }
        if(fristdevice.HumiWarningLow===fristdevice.HumiWarningHigh){
            isShowBoundWH = false
            
        }
        let th = fristdevice.TempAlarmHigh;
        let tl = fristdevice.TempAlarmLow;
        let hh = fristdevice.HumiAlarmHigh;
        let hl = fristdevice.HumiAlarmLow;
        devicestateTemp.map(m=>{
            if(isShowBound){
                if(m.Sensor.TempAlarmLow !==tl||m.Sensor.TempAlarmHigh!==th){
                    isShowBound = false
                    th =0;
                    tl =0;
                    hh = 0;
                    hl = 0;
                }else{
                    if(isHumi&&(m.Sensor.HumiAlarmHigh!==hh||m.Sensor.HumiAlarmLow!==hl)){
                        isShowBound = false
                        th =0;
                        tl =0;
                        hh = 0;
                        hl = 0;
                    }
                }
            }
            if(isShowBoundWT){
                if(m.Sensor.TempWarningHigh!==fristdevice.TempWarningHigh){
                    isShowBoundWT = false
                }
            }
            if(isShowBoundWH){
                if(m.Sensor.HumiWarningHigh!==fristdevice.HumiWarningHigh){
                    isShowBoundWH = false
                }
            }
            
        })
        setDataWarnT({tl:fristdevice.TempWarningLow,th:fristdevice.TempWarningHigh})
        setDataWarnH({tl:fristdevice.HumiWarningLow,th:fristdevice.HumiWarningHigh})
        setShowBoundWarnT(isShowBoundWT)
        setShowBoundWarnH(isShowBoundWH)
        setShowBound(isShowBound)
        setDataWainF({th,tl,hh,hl});
        let url = "/v1"; 
        let start = '';
        let end ='';
        // 普通报表
        
        
        if(tableType===0){
            var now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
            (!selTime)&&setStartTime(formatDateTimes(now_date.getTime()));
            (!selTime)&&setEndTime(formatDateTimes(new Date().getTime()));
            start=startTime===''?formatDateTimes(now_date.getTime()):startTime;
            end=endTime===''? formatDateTimes(new Date().getTime()):endTime;
            url += "/history?device=" + selDevT.sn  
            url+="&min="+interval+"&node=" + selNodes ;
            let days = splitRangeByDay(start,end)
            const tasks = [];
            setLoading(true);
            days.forEach(element => {
                let geturl=url + "&starttime=" +element.start+"&endtime=" + element.end
                tasks.push(
                    http.get(geturl, {})
                );
            });
            await getBatchTasks(tasks, 5).then(otherPagesData => {
                // 第四步：整合数据
                // 把第一页的数据放在最前面，后面接上其他页的数据
                // return [dataF, ...otherPagesData].flat();
                setLoading(false);
                if(selDev_){
                    hisDataDeal([...otherPagesData],start,end,selDev_,selNodes_,selDevs_);
                }else{
                    hisDataDeal([...otherPagesData],start,end);
                }
            })
            
        }else{
            let dataF =[]
            // 周期报表
            if( tableType===3&&monthTime==='')return message.warning('未选择月份');
            if( tableType===2&&startWeek==='')return message.warning('未选择星期');
            if( tableType===1&&startWeek==='')return message.warning('未选择时间');
            let time ='';
            AMTimes.map(item=>item<10?time+=('0'+item+':00:00,'):time+=(item+':00:00,'));
            PMTimes.map(item=>time+=(item+':00:00,'));
            time=time.slice(0,-1);
            tableType===3?url+="/historymon?device=":url+="/historyweek?device=";
            url+=selDevT.sn  + "&time=" + time;
            if(tableType===3){
                url+=('&mon='+monthTime)
            }else{
                if(endWeek===''){
                    const end = formatDateTimes(new Date().getTime())
                    setEndTime(end)
                    url+='&starttime='+startWeek+'&endtime='+end;
                }else{
                    url+='&starttime='+startWeek+'&endtime='+endWeek;
                }
            }
            url+="&min="+interval+"&node=" + selNodes ;
            setLoading(true);
            await http.get(url,{}).then((data) => {
                setLoading(false);
                if (data.code === 0) {
                    if (data.data===null||data.data.length === 0) return message.warning('暂无数据');
                    dataF.push(data.data)
                }
            })
            if(selDev_){
                hisDataDeal(dataF,startTime,endTime,selDev_,selNodes_,selDevs_)
            }else{
                hisDataDeal(dataF,startTime,endTime)
            }
            
            dataF=null;
        }
    }

    function getHisData2(){
        setDataF({tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 });
        setdataChart([]);
        setData([]);
        setSeriesTempData([])
        if (selDevice.sn === undefined || selDevice.node === undefined) return message.warning('未选择设备');
        let isShowBoundWT = true
        let isShowBoundWH = true
        let selNodes= selDevice.type===214?selNode.filter(x=>x!==0):selNode
        let devicestateTemp = state_device.devicestate.filter(x=>x.Sn===selDevice.sn&&selNodes.includes(x.Node))
        let fristdevice = devicestateTemp[0].Sensor;
        if(fristdevice.TempWarningLow===fristdevice.TempWarningHigh){
            isShowBoundWT = false
        }
        if(fristdevice.HumiWarningLow===fristdevice.HumiWarningHigh){
            isShowBoundWH = false
            
        }
        devicestateTemp.map(m=>{
            if(isShowBoundWT){
                if(m.Sensor.TempWarningHigh!==fristdevice.TempWarningHigh){
                    isShowBoundWT = false
                }
            }
            if(isShowBoundWH){
                if(m.Sensor.HumiWarningHigh!==fristdevice.HumiWarningHigh){
                    isShowBoundWH = false
                }
            }
            
        })
        setDataWarnT({tl:fristdevice.TempWarningLow,th:fristdevice.TempWarningHigh})
        setDataWarnH({tl:fristdevice.HumiWarningLow,th:fristdevice.HumiWarningHigh})
        setShowBoundWarnT(isShowBoundWT)
        setShowBoundWarnH(isShowBoundWH)
        let url = "/v1"; 
        let start = '';
        let end ='';
        // 普通报表
        if(tableType===0){
            var now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
            startTime===''&&setStartTime(formatDateTimes(now_date.getTime()));
            endTime===''&&setEndTime(formatDateTimes(new Date().getTime()));
            start=startTime===''?formatDateTimes(now_date.getTime()):startTime;
            end=endTime===''? formatDateTimes(new Date().getTime()):endTime;
            url += "/historygrounp?device=" + selDevice.sn  + "&starttime=" ;
            url+=start+"&endtime=" + end;
        }else{
            // 周期报表
            if( tableType===3&&monthTime==='')return message.warning('未选择月份');
            if( tableType===2&&startWeek==='')return message.warning('未选择星期');
            if( tableType===1&&startWeek==='')return message.warning('未选择时间');
            let time ='';
            AMTimes.map(item=>item<10?time+=('0'+item+':00:00,'):time+=(item+':00:00,'));
            PMTimes.map(item=>time+=(item+':00:00,'));
            time=time.slice(0,-1);
            
            tableType===3?url+="/historymon?device=":url+="/historyweek?device=";
            url+=selDevice.sn  + "&time=" + time;
            tableType===3?url+=('&mon='+monthTime):endWeek!==''?url+='&starttime='+startWeek+'&endtime='+endWeek:
            url+='&starttime='+startWeek+'&endtime='+formatDateTimes(new Date().getTime());
        }
        url+="&min="+interval+"&node=" + selNodes ;
        setLoading(true);
        setIsHumi(false);
        http.get(url, {})
        .then((data) => { 
            setLoading(false);
        })
    }

    const handleDevChange = (value) => {
        setShowDevName(value)
        //初始化
        setDataF({tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 });
        setdataChart([]);
        setData([]);
        let sd= state.device.filter(x => x.sn === value&&x.node>0&&!([1].includes(x.hide)))
        if(dis!==''){
            sd = sd.filter(x =>  x.district === dis)
        }

        if (sd.length > 0) {
            setSelDevice(sd[0]);
            setUserName(sd[0].user_name);
            setIsHumi(sd[0].humi===0?false:true)
        } else {
            setSelDevice({});
            setSelNode([])
            return
        }
        setSelDevs(sd);
        var nodes = new Array();
        sd.map(m=>{
            nodes.push(m.node);
        })
        setSelNode(nodes);
        
    }
    const handleNodeChange=(value)=>{
        setShowNodeName(value);
        //初始化
        setDataF({tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 });
        setdataChart([]);
        setData([]);
        const sd = state.device.filter(x => { return value.indexOf(x.id) > -1 });
        if (sd.length > 0) {
            setSelDevice(sd[0]);
            setUserName(sd[0].user_name);
            setSelNodeType(sd[0].type);
        } else {
            setSelDevice({});
            setSelNode([])
            return
        }
        if(sd.length>1){
            sd.sort((a,b)=>a.node-b.node); 
        }
        setSelDevs(sd);
        var nodes = new Array();
        sd.map(m=>{
            nodes.push(m.node);
        })

        setSelNode(nodes);
    }
    const formatDuration = (totalMinutes) => {
        if (!totalMinutes || totalMinutes <= 0) return '-';
        
        // 假设一个月按30天计算，可根据实际业务调整
        const months = Math.floor(totalMinutes / (30 * 24 * 60));
        totalMinutes %= (30 * 24 * 60);
        
        const days = Math.floor(totalMinutes / (24 * 60));
        totalMinutes %= (24 * 60);
        
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
      
        // 拼接字符串，过滤掉为 0 的单位
        const parts = [];
        if (months > 0) parts.push(`${months}个月`);
        if (days > 0) parts.push(`${days}天`);
        if (hours > 0) parts.push(`${hours}小时`);
        if (minutes > 0) parts.push(`${minutes}分`);
      
        return parts.join('') || '0分';
      };
    const tripCol =[
        {
            title: '序号',
            dataIndex: 'id',
            width: 80,
            align: 'center',
          },
          {
            title: '开始时间',
            dataIndex: 'start_time',

          },
          {
            title: '结束时间',
            dataIndex: 'end_time',
          },
          {
            title: '时长',
            dataIndex:'duration',
            render: (text,record) => formatDuration(record.duration)
          },
          {
            title: '状态',
            dataIndex: 'status',
            render: (status) => (
              <Tag color={status < 3? 'success' : 'processing'}>
                {status ===0 ? '正常完成' : status ===1 ? '开始正常' : status ===2 ? '结束正常' :'进行中'}
              </Tag>
            ),
          },
    ]
    const tabItems=[
        { 
            label: '报表显示', 
            key: '1', 
            children: (<div style={{height:'100%',backgroundColor:'#fff'}} className={isDataPage? 'tableshowData':Mode==='soc'?`hisshow tableshow1`:` local`}>
                {
                    hisType===0?
                    <Table 
                    rowKey={record =>record.data_time}
                    bordered
                    columns={[...columnsLeft, ...myTableCol]}
                    scroll={{ x: '80%', y :getScrollY()}}
                        // y:state.resolution.height>700?state.resolution.width>980?state.resolution.height-500:state.resolution.height-550:180}}
                    size={'small'} dataSource={currentData}  loading={loading}
                    pagination={{ showSizeChanger:true,current: tableCurrent, onChange:onChange_Table,total:recordCount,pageSize:tablePageSize,hideOnSinglePage:true}}
                    summary={() => (
                        showSimple?
                        <Table.Summary fixed>
                          {/* 最大值行 */}
                          <Table.Summary.Row>
                            <Table.Summary.Cell index={0}>最大值</Table.Summary.Cell>
                            {selDevSt.map((col,index) => (
                                <React.Fragment key={index}>
                                {/* 始终渲染温度单元格 */}
                                <Table.Summary.Cell index={2 * index + 1}>
                                  {col.temp_h}
                                </Table.Summary.Cell>
                            
                                {/* 只有当 humicount > 0 时，才渲染湿度单元格 */}
                                {col.humi > 0 && (
                                  <Table.Summary.Cell index={2 * index + 2}>
                                    {col.humi_h}
                                  </Table.Summary.Cell>
                                )}
                              </React.Fragment>
                            ))}
                          </Table.Summary.Row>
                          
                          {/* 最小值行 */}
                          <Table.Summary.Row>
                            <Table.Summary.Cell index={0}>最小值</Table.Summary.Cell>
                            {selDevSt.map((col,index) => (
                             <React.Fragment key={index}>
                             {/* 始终渲染温度单元格 */}
                             <Table.Summary.Cell index={2 * index + 1}>
                               {col.temp_l}
                             </Table.Summary.Cell>
                         
                             {/* 只有当 humicount > 0 时，才渲染湿度单元格 */}
                             {col.humi > 0 && (
                               <Table.Summary.Cell index={2 * index + 2}>
                                 {col.humi_l}
                               </Table.Summary.Cell>
                             )}
                           </React.Fragment>
                            ))}
                          </Table.Summary.Row>
                    
                          {/* 平均值行 */}
                          <Table.Summary.Row>
                            <Table.Summary.Cell index={0}>平均值</Table.Summary.Cell>
                            {selDevSt.map((col,index) => (
                             <React.Fragment key={index}>
                             {/* 始终渲染温度单元格 */}
                             <Table.Summary.Cell index={2 * index + 1}>
                               {col.temp_s}
                             </Table.Summary.Cell>
                         
                             {/* 只有当 humicount > 0 时，才渲染湿度单元格 */}
                             {col.humi > 0 && (
                               <Table.Summary.Cell index={2 * index + 2}>
                                 {col.humi_s}
                               </Table.Summary.Cell>
                             )}
                           </React.Fragment>
                            ))}
                          </Table.Summary.Row>
                        </Table.Summary>:null
                      )}
                    />:
                    <Table  bordered style={{fontFamily:'PingFang SC',fontWeight:400,fontSize:14,color:'#333',lineHeight:16}}  rowKey={record => record.data_time}
                    pagination={paginationConfig} onChange={handleTableChange} 
                    scroll={{ x: '80%',y :getScrollY()}}
                        // y:state.resolution.height>700?state.resolution.width>980?state.resolution.height-500:state.resolution.height-550:180}}
                    columns={selNodeColums} size='small' dataSource={data}/>
                    // <VirtualTable
                    //     columns={selNodeColums}
                    //     dataSource={data}
                    //     scroll={{
                    //     y: state.resolution.height>1000?440:state.resolution.height>800?280:160,
                    //     x: '60%',
                    //     }}
                    // />
                }
            </div>)
        },
        ...((hisType===0&&dataChart.length>0)?
            [{
            label: '时间轴曲线图', 
            key: '2', 
            children:(
                <div style={{backgroundColor:'#fff'}} className={Mode==='soc'?`hisshow tableshow1`:` local`}>
                    <div style={{display:'flex',flexDirection:'column',border: '1px solid #ebedf1'}}>
                        <div></div>
                        <div  id='tempEcharts' style={{height:state.resolution.height-400}} >
                            {/* <Line {...configtemp} /> */}
                        </div>
                        <div style={{display:'flex',justifyContent:'space-between',paddingRight:isDataPage?'14%':2,paddingLeft:50}}>
                            <div>
                                <span>开始时间:</span>
                                <span>{startTime}</span>
                            </div>
                            <div>
                                <span>结束时间:</span>
                                <span>{endTime}</span>
                            </div>
                        </div>
                    </div>
                </div>
            )
            }] : []),
        ...(dataChart.length>0?
        [{
        label: '温度曲线', 
        key: '3', 
        children:(
            <div style={{backgroundColor:'#fff',flex:1,paddingRight:isDataPage?'15%':0}} className={Mode==='soc'?`hisshow tableshow1`:` local`}>
                <div style={{display:'flex',flexDirection:'column',border: '1px solid #ebedf1',height:'100%'}}>
                    <div  id='tempEcharts' style={{height:state.resolution.height-400}}>
                        <Line {...configtemp} onReady={handleReady}/>
                    </div>
                </div>
                {
                    dataChart.length>0&&  !showBound&&
                    <div style={{textAlign:'center'}}>
                        <span style={{fontSize:10,color:'red'}}>您选择的测点包含多个温（湿）度区间或者是空库，故不展示区间辅助线</span>
                    </div>
                }
            </div>
        )
        }] : []),

        ...((isHumi&&dataChart.length>0)?
            [{
            label: '湿度曲线', 
            key: '4', 
            children:(
                <div style={{backgroundColor:'#fff',flex:1,paddingRight:isDataPage?'15%':0}} className={Mode==='soc'?`hisshow tableshow1`:` local`}>
                    <div style={{display:'flex',flexDirection:'column', border: '1px solid #ebedf1', padding: 10 ,height:'100%'}} >
                        <div id='tempEcharts' style={{height:state.resolution.height-400}}>
                            <Line {...confighumi} onReady={handleReady} />
                        </div>
                        
                    </div>
                    {
                        dataChart.length>0&& !showBound&&
                        <div style={{textAlign:'center'}}>
                            <span style={{fontSize:10,color:'red'}}>您选择的测点包含多个温（湿）度区间或者是空库，故不展示区间辅助线</span>
                        </div>
                    }
                </div>
            )
            }] : []),
        ...((co2Datas.length>0)?
            [{
            label: '二氧化碳浓度曲线', 
            key: '5', 
            children:(
                <div style={{backgroundColor:'#fff',flex:1,paddingRight:isDataPage?'15%':0}} className={Mode==='soc'?`hisshow tableshow1`:` local`}>
                <div style={{display:'flex',flexDirection:'column',border: '1px solid #ebedf1',height:'100%'}}>
                    <div  id='tempEcharts' style={{height:state.resolution.height-400}}>
                        <Line {...configco2} onReady={handleReady}/>
                    
                    </div>
                    
                </div>
            </div>
            )
            }] : []),
        ...((trips.length>0)?
        [{
        label: '行程统计', 
        key: '6', 
        children:(
            <Table  bordered style={{fontFamily:'PingFang SC',fontWeight:400,fontSize:14,color:'#333',lineHeight:16}}  rowKey={record => ''+record.id}
            columns={tripCol} size='small' dataSource={trips}/>
        )
        }] : []),
        
    ]
    return (
        <>
            <div id="devicechart">
                <div className='flexDiv'>
                    <div style={{border:'1px solid #ccc',margin: '5px 10px'}}>
                        {/* 设备选择 */}
                        <div style={{ display: 'flex', alignItems: 'center', padding:'5px 20px' }}>
                            {/* 区域选择 */}    
                            <div style={{display:'flex',alignItems:'center',flex:1}}>
                                <span style={{ fontSize: 14 }}>区域</span>
                                <Cascader style={{ width: 300, marginLeft: 10 }}
                                    options={userdistrict} expandTrigger="hover" placeholder="选择区域" autoFocus  allowClear
                                    value={selDis}
                                    onChange={val => {
                                        let arrDev = new Array();
                                        // setUserName(state.systemuser.list.filter(x=>x.id===val[val.length-2])[0].name);
                                        let arrNode = new Array();
                                        if(Mode!=='local'){
                                            arrDev=devFliters.filter(x=>(new Date(x.expire).getTime()>todayTime))
                                            arrNode = nodeFliters.filter(x=>(new Date(x.expire).getTime()>todayTime));
                                        }else{
                                            arrDev = devFliters
                                            arrNode = nodeFliters
                                        }
                                        setSelDevOptions(arrDev);
                                        setSelNodeOptions(arrNode);
                                        setShowDevName(null);
                                        setShowNodeName([]);
                                        setSelDevice({});
                                        setSelNodeColums([]);
                                        setSelNode([])
                                        if(!val||(val&&val.length===0)) {
                                            setSelDis(0)
                                            return
                                        }
                                        let seldis = 0;
                                        setSelDis(val)
                                        if(Mode==='local'){
                                            seldis = val[val.length - 1]*1
                                        }else{
                                            seldis = val[val.length - 1].slice(3)*1
                                        }
                                        
                                        // arrNode = new Array();
                                        // arrDev = new Array();
                                        // state.device.filter(x => x.district ===seldis &&x.node>0&&!([1].includes(x.hide))).sort((a, b) => a.sn - b.sn).map(m => {
                                        //     arrNode.push({ label: m.name+'-'+m.sn, value: m.id, sn: m.sn,expire:m.expire });
                                        //     arrDev.findIndex(x => x.value === m.sn) === -1 && arrDev.push({ label: m.m_name+'-'+m.sn, value: m.sn ,expire:m.expire});
                                        // })

                                        setDis(seldis);
                                        arrDev=arrDev.filter(x=>x.dis.includes(seldis))
                                        arrNode=arrNode.filter(x=>x.dis===seldis)
                                        if (arrNode.length === 0) {
                                            message.info('该区域下暂无设备信息');
                                            setSelNodeOptions([])
                                            setSelDevOptions([]);
                                        } else {
                                            // if(Mode!=='local'){
                                            //     arrDev=arrDev.filter(x=>(new Date(x.expire).getTime()>todayTime))
                                            //     arrNode = arrNode.filter(x=>(new Date(x.expire).getTime()>todayTime))
                                            // }
                                            console.log('arrDev',arrDev);
                                            
                                            setSelDevOptions(arrDev);
                                            setSelNodeOptions(arrNode);
                                        }
                                        
                                    }} showSearch={(inputValue, path) => path.some(opt => opt.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)} />
                            </div>
                            {
                                state.resolution.width<1280?
                                <div style={{ display: 'flex',flex:1,textAlign:'center',marginLeft:5,alignContent:'center'}} >
                                    <Button size='small' type='primary' style={{marginTop:5}} onClick={()=>{
                                        setQueryMode(!queryMode)
                                        setShowNodeName([])
                                        setShowDevName(null)
                                    }}>切换</Button>
                                    <div>
                                    {
                                        queryMode?<DevSelect
                                        selDevOptions={selDevOptions}
                                        showNodeName={showNodeName}
                                        showDevName={showDevName}
                                        onDataChange={handleDevChange}
                                       />:<NodeSelect
                                       selNodeOptions={selNode.length>0?selNodeOptions.filter(x=>x.sn===selDevice.sn):selNodeOptions}
                                       showNodeName={showNodeName}
                                       showDevName={showDevName}
                                       onDataChange={handleNodeChange}
                                       show={true}
                                      />
                                    }
                                    </div>
                                    
                                </div>
                                :
                                <div style={{ display: 'flex', alignItems: 'center',flex:2}} >
                                    {/* 主机方式查询 */}
                                    <DevSelect
                                        selDevOptions={selDevOptions}
                                        showNodeName={showNodeName}
                                        showDevName={showDevName}
                                        onDataChange={handleDevChange}
                                    />
                                    {/* <div style={{display:'flex',alignItems:'center',flex:1}}>
                                        <span margin-left='14px' style={{ fontSize: 14, marginLeft: 10 }}>主机</span>
                                    </div> */}
                                    {/* 测点方式查询 */}
                                    <NodeSelect
                                        selNodeOptions={selNode.length>0?selNodeOptions.filter(x=>x.sn===selDevice.sn):selNodeOptions}
                                        showNodeName={showNodeName}
                                        showDevName={showDevName}
                                        onDataChange={handleNodeChange}
                                        show={false}
                                    />
                                    {/* <div style={{display:'flex',alignItems:'center',flex:1}}>
                                        <span margin-left='14px' style={{ fontSize: 14, marginLeft: 10 }}>测点</span>
                                    </div> */}
                                </div>
                            }
                            
                            
                            {/* 查询 */}
                            {/* <Col xxl={1} xl={2} lg={2} style={{display:'flex',justifyContent:'space-between'}}> */}
                                <div >
                                {
                                selDevice?.type!==208 && selDevice?.type!==214&&
                                    <Button type={"primary"}  style={{borderRadius:10,marginRight:10}} disabled={loading}
                                    onClick={() => {
                                        // getHisData(1)
                                        getHisByPage(selNode,startTime,endTime,1,showUnitName)
                                        setHisType(1)
                                    }}>大数据查询</Button>
                                }
                                <Button type={"primary"}  style={{borderRadius:10}} disabled={loading}
                                    onClick={() => {
                                        getHisData(0)
                                        setHisType(0)
                                        setTableKey(Date.now().toString())
                                    }}>查询</Button>
                                     {
                                    Mode==='local' &&
                                    <div>
                                        {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
                                        <span style={{fontSize:10}}>&nbsp;</span>
                                    </div>
                                }
                                 
                                </div>   
                            {/* </Col> */}
                        </div>
                        {/*时间 报表类型选择   导出*/}
                        <Row align='middle'  style={{padding:'5px 20px'}} >
                            {/* 是否查询周期报表 */}
                            <Col xxl={2} xl={4} lg={4}>
                                <Checkbox onChange={e=>{
                                    if(e.target.checked){
                                        setTableType(3);
                                    }else{
                                        setTableType(0);
                                    }
                                    
                                }}>周期报表</Checkbox>
                            </Col>
                            {/* 周期报表查询 */}
                            <Col xxl={10} xl={tableType>0?16:0} lg={tableType>0?16:0}>
                                <div style={{display:'flex'}}>
                                    {/* 选择周期报表类型月报表|周报表|日报表 */}
                                    <div style={{marginLeft:10}}>
                                        <Tag color={tableType===3?"cyan":'green'} style={{fontSize:14,padding:5,borderRadius:10}}
                                            onClick={()=>{
                                                if(tableType===0)return
                                                setDateTime('');
                                                setMonthTime('');
                                                setStartWeek('');
                                                setEndWeek('');
                                                tableType===3?setTableType(2):tableType===2?setTableType(1):setTableType(3);
                                            }}
                                        >
                                            {tableType===1?'日报表':tableType===2?'周报表':'月报表'}
                                        </Tag>
                                    </div>
                                    {/* 选择周期报表每天上午的时间点 */}
                                    <div style={{marginLeft:10,display:'flex',width:150,alignItems:'center'}}>
                                        <div><span style={{fontSize:14}}>上午:</span></div>
                                        <Select
                                            mode="multiple"
                                            allowClear
                                            style={{ width: '60%',marginLeft:10 }}
                                            placeholder="选择时间点"
                                            defaultValue={[9]}
                                            options = {AMOptions}
                                            onChange={value=>setAMTimes(value)}
                                        />
                                    </div>
                                    {/* 选择周期报表每天下午的时间点 */}
                                    <div style={{marginLeft:10,display:'flex',width:160,alignItems:'center'}}>
                                        <div ><span>下午:</span></div>
                                        <Select
                                            mode="multiple"
                                            allowClear
                                            style={{ width: '60%',marginLeft:10 }}
                                            placeholder="选择时间点"
                                            defaultValue={[15]}
                                            options = {PMOptions}
                                            onChange={value=>setPMTimes(value)}
                                        />
                                    </div>
                                    {/* 选择周期报表查询时间段 */}
                                    <div>
                                        {
                                            tableType===1?
                                            <RangePicker style={{ marginLeft: 10 ,borderRadius:10}}
                                                allowEmpty={[false,true]}
                                                ranges={myDayRanges}
                                                format="YYYY-MM-DD"
                                                onChange={(dates, dateStrings) => {
                                                    if(dates===null){
                                                        setStartWeek('');
                                                        setEndWeek('');
                                                    }else{
                                                        const start = dateStrings[0]+' 00:00:00'
                                                        setStartWeek(start);
                                                        setStartTime(start)
                                                        if(dates[1]!==null){
                                                            const end = dateStrings[1]+' 23:59:59'
                                                            setEndWeek(end);
                                                            setEndTime(end);
                                                        }
                                                    }
                                                    // if (dateStrings[0] !== "") {
                                                    //     setStartWeek(dateStrings[0]+' 00:00:00');
                                                    //     setEndWeek(dateStrings[1]+' 23:59:59');
                                                    // }
                                                }}
                                            />
                                            :
                                            <DatePicker style={{borderRadius:10}}  picker={tableType===1?'date':tableType===2?"week":'month' } 
                                            value={dateTime}  
                                            format={tableType===2&&customWeekStartEndFormat}
                                            onChange ={(value,time)=>{
                                                setDateTime(value)
                                                if(tableType===2){
                                                    const start = moment(value).startOf('week').format('yyyy-MM-DD HH:mm:ss')
                                                    const end = moment(value).endOf('week').format('yyyy-MM-DD HH:mm:ss')
                                                    setStartWeek(start);
                                                    setEndWeek(end);
                                                    setStartTime(start)
                                                    setEndTime(end);
                                                }else if(tableType===3){
                                                    const start = moment(value).startOf('month').format('yyyy-MM-DD HH:mm:ss')
                                                    const end = moment(value).endOf('month').format('yyyy-MM-DD HH:mm:ss')
                                                    setStartTime(start)
                                                    setEndTime(end);
                                                    setMonthTime(time+'-01');
                                                }else{
            
                                                }
                                            }}
                                            />
                                        }
                                    </div>
                                </div>
                            </Col>
                            {/* 普通报表查询 */}
                            <Col xxl={9} xl={tableType===0?16:0} lg={tableType===0?16:0}>
                                <div style={{display:'flex'}}>
                                    {/* 时间选择 */}
                                    <div>
                                        <span margin-left='14px' style={{ fontSize: 14,  }}>时间</span>
                                        <RangePicker style={{ marginLeft: 10 ,borderRadius:10}}
                                            allowEmpty={[false,true]}
                                            ranges={myTimeRanges}
                                            showTime
                                            format="YYYY-MM-DD HH:mm"
                                            onChange={handleTimeChange}
                                        />
                                    </div>
                                    {/* 间隔选择 */}
                                    <div>
                                        <span margin-left='14px' style={{ fontSize: 14, marginLeft:20 }}>间隔</span>
                                        {
                                            // Mode!=='soc'&&
                                            <Select
                                            showSearch
                                            style={{ width: 80 ,marginLeft:10}}
                                            placeholder="间隔"
                                            optionFilterProp="children"
                                            filterOption={(input, opt) =>
                                            opt.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            filterSort={(optionA, optionB) =>
                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                            }
                                            onChange={value=>setInterval(value)}
                                        >
                                            <Option value="1">1</Option>
                                            <Option value="2">2</Option>
                                            <Option value="5">5</Option>
                                            <Option value="10">10</Option>
                                            <Option value="20">20</Option>
                                            <Option value="30">30</Option>
                                            <Option value="60">60</Option>
                                        </Select>
                                        }
                                    </div>
                                    
                                </div>
                            </Col>
                            
                            <Col xxl={3} xl={4} lg={4} style={{display:'flex',justifyContent:'right'}}>
                                <div style={{display:'flex',justifyContent:'space-between'}}>
                                    {
                                        selNode.length>1&& <Checkbox style={{fontSize:12}} onChange={(e)=>setShowSimple(e.target.checked)}>简化</Checkbox>
                                    }   
                                    <Checkbox checked={isPDFCol} style={{fontSize:12}} onChange={()=>setIsPDFCol(prev => !prev)}>单列</Checkbox>
                                <div>
                                    <Dropdown trigger={'click'} disabled={loading}
                                        overlay={
                                        <Menu>
                                            {
                                                isHumi&&<Menu.Item key="0">
                                            
                                                    <Checkbox style={{marginLeft:5}} checked={isExportHumi}  onChange={(e)=>{
                                                        e.target.checked?setIsExportHumi(true):setIsExportHumi(false);
                                                    }}>导出湿度</Checkbox>
                                                
                                                </Menu.Item>
                                            }
                                            
                                            <Menu.Item key="1">
                                                { isMoreThan31Days(startTime,endTime) ? (
                                                <Popconfirm
                                                    title={ "时间跨度较大，导出可能失败，是否继续？"}
                                                    onConfirm={() => exportPDF()}
                                                    okText="确定"
                                                    cancelText="取消"
                                                    disabled={loading}
                                                >
                                                    导出PDF
                                                </Popconfirm>
                                                ) : (
                                                // 不需要确认时，点击菜单项直接触发事件
                                                <div style={{ border: "0px none", cursor: 'pointer' }} disabled={loading} onClick={() => {
                                                    exportPDF();
                                                }}>导出PDF</div>
                                                )}
                                            </Menu.Item>
                                            {
                                                !showHisModeNew&&
                                                <Menu.Item key="3">
                                                    { isMoreThan31Days(startTime,endTime) ? (
                                                <Popconfirm
                                                    title={ "时间跨度较大，导出可能失败，是否继续？"}
                                                    onConfirm={() => exportPDF(1)}
                                                    okText="确定"
                                                    cancelText="取消"
                                                    disabled={loading}
                                                >
                                                    PDF(基础)
                                                </Popconfirm>
                                                ) : (
                                                    <div style={{ border: "0px none", cursor: 'pointer' }} disabled={loading} onClick={() => {
                                                        exportPDF(1);
                                                    }}>PDF(基础)</div>
                                                )}
                                                </Menu.Item>
                                            }
                                            
                                            {
                                                state.super>1&& <Menu.Item key="2">
                                                    <div style={{ border: "0px none", cursor: 'pointer' }} disabled={loading} onClick={() => {
                                                        exportExcel()
                                                    }}>导出EXCEL</div>
                                                </Menu.Item>
                                            }
                                            {
                                                state.super>1&& <Menu.Item key="4">
                                                    <div style={{ border: "0px none", cursor: 'pointer' }} disabled={loading} onClick={() => {
                                                        exportExcel(1)
                                                    }}>EXCEL(基础)</div>
                                                </Menu.Item>
                                            }
                                        
                                        </Menu>
                                    }>
                                        <Button type={"primary"}  style={{borderRadius:10}}>
                                            {/* <Space> */}
                                            导出
                                            <DownOutlined />
                                            {/* </Space> */}
                                        </Button>
                                    </Dropdown>   
                                    {
                                        Mode==='local' &&
                                        <div>
                                            {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
                                            <span style={{color:'red',fontSize:10}}>可导出不能导入</span>
                                        </div>
                                    }
                                </div> 
                                </div>                      
                            </Col>
                        </Row>
                    </div>
                    
                    {/* 数据展示区 */}
                    <div style={{ padding: '10px 20px', margin: '5px 10px',flex:1,border:'1px solid #ccc'}}className='flexDiv'>
                        {
                            loading ? <Progress percent={getDataPro} style={{ margin: '10px 0' }} />:
                            hisType===0&&
                            <div style={{ padding: 5, border: '1px solid #ebedf1', }}>
                                <div style={{ display:selNodeType===218?'none' :'flex', justifyContent: 'space-between' }}>
                                    <div>{selNodeType===205?'压强(Pa)':'温度(℃)'}: </div>
                                    {showHisLimit&&<div>上限值:{data.length > 0 ? data[0][0].temp_h : ''}</div>}
                                    {showHisLimit&&<div>下限值:{data.length > 0 ? data[0][0].temp_l : ''}</div>}
                                    <div >最大值:{dataF.tmax}</div>
                                    <div>最小值:{dataF.tmin}</div>
                                    <div >平均值:{dataF.tavg.toFixed(2)}</div>
                                    {
                                        isHumi&&<div >湿度(%RH): </div>
                                    }
                                    {
                                        isHumi&&showHisLimit&&<div >上限值:{data.length > 0 ? data[0][0].humi_h : ''}</div>
                                    }
                                    {
                                        isHumi&&showHisLimit&&<div >下限值:{data.length > 0 ? data[0][0].humi_l : ''}</div>
                                    }
                                    {
                                        isHumi&&<div >最大值:{dataF.hmax}</div>
                                    }
                                    {
                                        isHumi&&<div >最小值:{dataF.hmin}</div>
                                    }
                                    {
                                        isHumi&&<div>平均值:{dataF.havg.toFixed(2)}</div>
                                    }
                                </div>
                            </div>
                        }
                        <div className='flexDiv' style={{flex:1}}>
                        <Spin spinning={loading} size="large" tip="加载中..." />
                        <Tabs key={tableKey} defaultActiveKey= "1" activeKey={tabKey}  className={`flexDiv`} style={{height:'70vh', visibility:loading?'hidden':'visible',overflow:'hidden'}} 
                            tabBarExtraContent={
                                data&&data.length>0&&
                                <div style={{paddingRight:20}}>
                                    {/* 保存为图片 */}
                                    <Button style={{ borderRadius:10 ,fontSize:12}} onClick={() => {
                                        setLoading(true);
                                        var canvas2 = document.createElement("canvas");
                                        let _canvas = document.getElementById('devicechart');
                                        var w = parseInt(window.getComputedStyle(_canvas).width);
                                        var h = parseInt(window.getComputedStyle(_canvas).height);
                                        canvas2.width = w ;
                                        canvas2.height = h ;
                                        var context = canvas2.getContext("2d");
                                        context.scale(1, 1);
                                        html2canvas(document.getElementById('devicechart'), { canvas: canvas2 }).then((canvas) => {
                                            // canvas.style.width = (w - 40) + "px";
                                            // canvas.style.height = (h - 40) + "px";
                                            canvas.id = 'cutimg'
                                            var url = canvas.toDataURL('image/png');
                                            if(window.CefSharp!==undefined){
                                                window.CefSharp.BindObjectAsync("bound");
                                                window.bound.exportImg(url);
                                     
                                            }else{
                                                var downloadLink = document.createElement("a");
                                                downloadLink.href = url;
                                                downloadLink.download = "sd.png";
                                                downloadLink.click();
                                                
                                            }
                                            setLoading(false);
                                        });
                                        let logmsg = `保存设备${selDevice.sn}中测点ID为 ${selNode}的时间，${startTime}到${endTime}之间的历史数据的${tabKey==='1'?'表格':
                                            tabKey==='2'?'时间轴曲线图':tabKey==='3'?'温度曲线':'湿度曲线'}形式的图片`;
                                        let log={
                                            operator:'',
                                            district:state.device.filter(item=>item.sn===selDevice.sn)[0]?.district_name,
                                            content:logmsg,
                                            result:'导出成功',
                                            contentData:null
                                        }
                                        http.post('/v1/userlog', {
                                            user: state.main.id,
                                            type: 301,
                                            method: 'POST',
                                            log: JSON.stringify(log),
                                            time:formatDateTimes(new Date()),
                                            username:state.main.name,
                                            usertype:state.main.type,
                                            signa:''
                                        }).then(res => {

                                        })
                                    }}>保存为图片</Button>
                                    {/* 下载EXCEL */}
                                    {
                                        state.super>1&&
                                        <Button style={{marginLeft:5,borderRadius:10,fontSize:12}} disabled={state.main.role.indexOf(304)===-1||loading}
                                    onClick={() => {
                                        exportExcel()
                                    }}>导出EXCEL</Button>
                                    }
                                    {
                                        state.super>1&&
                                        <Button style={{marginLeft:5,borderRadius:10,fontSize:12}} disabled={state.main.role.indexOf(304)===-1||loading}
                                    onClick={() => {
                                        exportExcel(1)
                                    }}>EXCEL(基础)</Button>
                                    }
                                    
                                    {/* 下载PDF */}
                                    { isMoreThan31Days(startTime,endTime) ? (
                                    <Popconfirm
                                        title={ "时间跨度较大，导出可能失败，是否继续？"}
                                        onConfirm={() => exportPDF()}
                                        okText="确定"
                                        cancelText="取消"
                                        disabled={state.main.role.indexOf(304)===-1||loading}
                                    >
                                        <Button style={{marginLeft:5,borderRadius:10,fontSize:12}}>导出PDF</Button>
                                    </Popconfirm>
                                    ) : (
                                    <Button style={{marginLeft:5,borderRadius:10,fontSize:12}} disabled={state.main.role.indexOf(304)===-1||loading}
                                    onClick={() => {
                                        exportPDF();
                                    }}>导出PDF</Button>
                                    )}
                                    {
                                        !showHisModeNew&& (isMoreThan31Days(startTime,endTime) ? (
                                            <Popconfirm
                                                title={ "时间跨度较大，导出可能失败，是否继续？"}
                                                onConfirm={() => exportPDF(1)}
                                                okText="确定"
                                                cancelText="取消"
                                                disabled={state.main.role.indexOf(304)===-1||loading}
                                            >
                                                <Button style={{marginLeft:5,borderRadius:10,fontSize:12}}>PDF(基础)</Button>
                                            </Popconfirm>
                                            ) : (
                                        
                                        <Button style={{marginLeft:5,borderRadius:10,fontSize:12}} disabled={state.main.role.indexOf(304)===-1||loading}
                                        onClick={() => {
                                            exportPDF(1);
                                        }}>PDF(基础)</Button>))
                                    }
                                    
                                    {
                                        tabKey==='2'&& selNode.length===1&&
                                        <Button style={{ borderRadius:10 ,fontSize:12}} onClick={e=>{
                                            var printContent = document.querySelector('.print-me');
                                            var windowContent = printContent.innerHTML;
                                            let imgUrl = getChartImage();
                                            var printWindow = window.open('', '_blank');
                                            printWindow.document.write('<html><head><title>打印</title>');
                                            printWindow.document.write('</head><body >');
                                            printWindow.document.write(windowContent);
                                            printWindow.document.write("<img src='" + imgUrl + "' alt='ECharts 折线图'/>");
                                            printWindow.document.write('</body></html>');
                                            printWindow.document.close();
                                            printWindow.print();
                                            printWindow.close();
                                    }}>打印</Button>
                                    }
                                    {
                                        isHumi&&<Checkbox style={{marginLeft:5}} checked={isExportHumi} onChange={(e)=>{
                                            e.target.checked?setIsExportHumi(true):setIsExportHumi(false);
                                        }}>湿度</Checkbox>
                                    }
                                    {
                                        Mode==='local' &&
                                        <div>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <span style={{color:'red',fontSize:10}}>只可导出不能导入</span>
                                        </div>
                                    }
                                    
                                    
                                </div>
                            } 
                            onChange={onChange_Tab} items={tabItems}>

                        </Tabs>
                            
                        </div>
                    </div>
                    {/* 下载区 */}
                    <div style={{ marginTop: 10, textAlign: 'right' }}>
                        <a id="downloadDiv" style={{ display: 'none' }}></a>
                    </div>
                </div>
                {/* 打印 */}
                <div className='print-me' style={{display:'none'}}>
                    <div style={{fontSize:26}}>
                        <span>设备编号：</span>
                        <span style={{marginLeft:5}}>{selDevice.sn}</span>
                        <span style={{marginLeft:10}}>用户：</span>
                        <span style={{marginLeft:5}}>{state.main.name}</span>
                        <span style={{marginLeft:10}}>单位：</span>
                        <span style={{marginLeft:5}}>{userName}</span>
                    </div>
                    <div style={{fontSize:26}}>
                        <span>区域：</span>
                        <span style={{marginLeft:5}}>{selDevice.district_name}</span>
                        <span style={{marginLeft:20}}>名称：</span>
                        <span style={{marginLeft:5}}>{`${selDevice.name}-探头编号-${selDevice.node}`}</span>
                    </div>
                    <div style={{fontSize:26}}>
                        <span>开始时间：</span>
                        <span style={{marginLeft:5}}>{startTime}</span>
                        <span style={{marginLeft:20}}>结束时间：</span>
                        <span style={{marginLeft:5}}>{endTime}</span>
                    </div>
                    <div style={{fontSize:26}}>
                        <span>温度</span>
                        <span style={{marginLeft:20}}>最大值：</span>
                        <span style={{marginLeft:5}}>{selDevice.type===211?dataF.tmax.toFixed(2):dataF.tmax.toFixed(1)}</span>
                        <span style={{marginLeft:20}}>最小值：</span>
                        <span style={{marginLeft:5}}>{selDevice.type===211?dataF.tmin.toFixed(2):dataF.tmin.toFixed(1)}</span>
                        <span style={{marginLeft:20}}>平均值：</span>
                        <span style={{marginLeft:5}}>{selDevice.type===211?dataF.tavg.toFixed(2):dataF.tavg.toFixed(1)}</span>
                    </div>
                    {
                        selDevice.humi===1&&
                        <div style={{fontSize:26}}>
                            <span>湿度</span>
                            <span style={{marginLeft:20}}>最大值：</span>
                            <span style={{marginLeft:5}}>{}</span>
                            <span style={{marginLeft:5}}>{selDevice.type===211?dataF.hmax.toFixed(2):dataF.hmax.toFixed(1)}</span>
                            <span style={{marginLeft:20}}>最小值：</span>
                            <span style={{marginLeft:5}}>{selDevice.type===211?dataF.hmin.toFixed(2):dataF.hmin.toFixed(1)}</span>
                            <span style={{marginLeft:20}}>平均值：</span>
                            <span style={{marginLeft:5}}>{selDevice.type===211?dataF.havg.toFixed(2):dataF.havg.toFixed(1)}</span>
                        </div>
                    }
                    <div>
                        <table style={{textAlign:'center',fontSize:26}}>
                            <thead >
                                <tr>
                                    <th style={{border:'1px solid #ccc'}}>时间</th>
                                    <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>温度</th>
                                    {
                                        selDevice.humi===1&&
                                        <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc',borderLeft:'1px solid #ccc'}}>湿度</th>
                                    }
                                    
                                    <th style={{border:'1px solid #ccc'}}>时间</th>
                                    <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>温度</th>
                                    {
                                        selDevice.humi===1&&
                                        <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc',borderLeft:'1px solid #ccc'}}>湿度</th>
                                    }
                                    <th style={{border:'1px solid #ccc'}}>时间</th>
                                    <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc',borderRight:'1px solid #ccc'}}>温度</th>
                                    {
                                        selDevice.humi===1&&
                                        <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc',borderRight:'1px solid #ccc'}}>湿度</th>
                                    }
                                    {/* <th style={{border:'1px solid #ccc'}}>时间</th>
                                    <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>温度</th>
                                    {
                                        selDevice.humi===1&&
                                        <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>湿度</th>
                                    } */}
                                </tr>
                                
                            </thead>
                            <tbody>
                                {
                                    selNode.length===1&&(selDevs[0].type!==218||(selDevs[0].type===218&&selNode[0]%2!==0))&&
                                    dataP.map((item,index) => {
                                        if(index%3===0){
                                            return<tr key={index}>
                                            <td style={{border:'1px solid #ccc'}}>{item.data_time}</td>
                                            <td style={{width:80,marginLeft:5,borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>
                                                {item.temp_switch===0?'--':
                                    (item.temp===102.2||item.temp===102.3||item.temp===-102.2||item.temp===-102.3||item.temp===null)?'NL':item.type===211?item.temp.toFixed(2):item.temp.toFixed(1)}</td>
                                            {
                                                selDevice.humi===1&&
                                                <td style={{width:80,marginLeft:5,borderLeft:'1px solid #ccc',borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>
                                                    {(item.humi===102.2||item.humi===102.3||item.humi===-102.2||item.humi===-102.3)?'NL':item.humi.toFixed(1)}
                                                </td>
                                            }
                                            {
                                                ((index+1)<recordCount*1)&&<td style={{border:'1px solid #ccc'}}>{dataP[index+1]?.data_time}</td>
                                            }
                                            {
                                                ((index+1)<recordCount*1)&&<td style={{width:80,marginLeft:5,borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>
                                                    {dataP[index+1]?.temp_switch===0?'--':
                                                    (dataP[index+1]?.temp===102.2||dataP[index+1]?.temp===102.3||dataP[index+1]?.temp===-102.2||dataP[index+1]?.temp===-102.3)?'NL':dataP[index+1]?.type===211?dataP[index+1]?.temp.toFixed(2):dataP[index+1]?.temp.toFixed(1)
                                                    }
                                                </td>
                    
                                            }
                                            {
                                                ((index+1)<recordCount*1)&&selDevice.humi===1&&
                                                <td style={{width:80,marginLeft:5,borderLeft:'1px solid #ccc',borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>
                                                    {(dataP[index+1]?.humi===102.2||dataP[index+1]?.humi===102.3||dataP[index+1]?.humi===-102.2||dataP[index+1]?.humi===-102.3)?'NL':dataP[index+1]?.humi.toFixed(1)}
                                                </td>
                                            }    
                                            {
                                                ((index+2)<recordCount*1)&&(<td style={{border:'1px solid #ccc'}}>{dataP[index+2]?.data_time}</td>)
                                            }
                                            {
                                                ((index+2)<recordCount*1)&&(<td style={{width:80,marginLeft:5,borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc',borderRight:'1px solid #ccc'}}>
                                                    {dataP[index+2]?.temp_switch===0?'--':(dataP[index+2]?.temp===102.2||dataP[index+2]?.temp===102.3||dataP[index+2]?.temp===-102.2||dataP[index+2]?.temp===-102.3)?'NL':
                                                dataP[index+2]?.type===211?dataP[index+2]?.temp.toFixed(2):dataP[index+2]?.temp.toFixed(1)}
                                                </td>)
                                            }
                                            {
                                                ((index+2)<recordCount*1)&&selDevice.humi===1&&
                                                <td style={{width:80,marginLeft:5,borderRight:'1px solid #ccc',borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>
                                                    {(dataP[index+2]?.humi===102.2||dataP[index+2]?.humi===102.3||dataP[index+2]?.humi===-102.2||dataP[index+2]?.humi===-102.3)?'NL':dataP[index+2]?.humi.toFixed(1)}
                                                </td>
                                            }
                                            {/* {
                                                ((index+3)<recordCount)&&(<td style={{borderLeft:'1px solid #ccc'}}>{data[index+3].data_time}</td>)
                                            }
                                            {
                                                ((index+3)<recordCount)&&(<td style={{width:80,marginLeft:5,borderLeft:'1px solid #ccc'}}>{data[index+3].temp_switch===0?'--':
                                    (data[index+3].temp===102.2||data[index+3].temp===102.3||data[index+3].temp===-102.2||data[index+3].temp===-102.3)?'NL':data[index+3].type===211?data[index+3].temp.toFixed(2):data[index+3].temp.toFixed(1)}</td>)
                                            }
                                            {
                                                ((index+3)<recordCount)&&selDevice.humi===1&&
                                                <td style={{width:80,marginLeft:5,borderLeft:'1px solid #ccc'}}>
                                                    {(data[index+3].humi===102.2||data[index+3].humi===102.3||data[index+3].humi===-102.2||data[index+3].humi===-102.3)?'NL':data[index+3].humi.toFixed(1)}
                                                </td>
                                            } */}
                                        </tr>
                                        }
                                    }
                                        
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default History